/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route";
import { Route as PdfRouteRouteImport } from "./routes/pdf/route";
import { Route as SignupRouteImport } from "./routes/signup";
import { Route as AuthenticatedUserRouteRouteImport } from "./routes/_authenticated/user/route";
import { Route as ConnectTiktokRouteImport } from "./routes/connect/tiktok";
import { Route as ShopifyInstallRouteImport } from "./routes/shopify/install";
import { Route as SigninIndexRouteImport } from "./routes/signin/index";
import { Route as SigninResetpasswordRouteImport } from "./routes/signin/resetpassword";
import { Route as AuthenticatedMcpAuthorizeRouteImport } from "./routes/_authenticated/mcp/authorize";
import { Route as AuthenticatedOnboardingV2RouteRouteImport } from "./routes/_authenticated/onboarding/v2/route";
import { Route as AuthenticatedUserIndexRouteImport } from "./routes/_authenticated/user/index";
import { Route as AuthenticatedUserAmzsummaryRouteImport } from "./routes/_authenticated/user/amzsummary";
import { Route as AuthenticatedUserApplicationsRouteImport } from "./routes/_authenticated/user/applications";
import { Route as AuthenticatedUserBillingRouteImport } from "./routes/_authenticated/user/billing";
import { Route as AuthenticatedUserCategorymanagementRouteImport } from "./routes/_authenticated/user/categorymanagement";
import { Route as AuthenticatedUserChromeaccessRouteImport } from "./routes/_authenticated/user/chromeaccess";
import { Route as AuthenticatedUserDashboardRouteImport } from "./routes/_authenticated/user/dashboard";
import { Route as AuthenticatedUserDataStatusRouteImport } from "./routes/_authenticated/user/data-status";
import { Route as AuthenticatedUserGoalsRouteImport } from "./routes/_authenticated/user/goals";
import { Route as AuthenticatedUserLiveRouteRouteImport } from "./routes/_authenticated/user/live/route";
import { Route as AuthenticatedUserMcpRouteImport } from "./routes/_authenticated/user/mcp";
import { Route as AuthenticatedUserMerchandisingRouteRouteImport } from "./routes/_authenticated/user/merchandising/route";
import { Route as AuthenticatedUserPaymentRouteImport } from "./routes/_authenticated/user/payment";
import { Route as AuthenticatedUserPlRouteRouteImport } from "./routes/_authenticated/user/pl/route";
import { Route as AuthenticatedUserPlansRouteImport } from "./routes/_authenticated/user/plans";
import { Route as AuthenticatedUserPricingRouteRouteImport } from "./routes/_authenticated/user/pricing/route";
import { Route as AuthenticatedUserProductlaunchRouteRouteImport } from "./routes/_authenticated/user/productlaunch/route";
import { Route as AuthenticatedUserProgramsRouteRouteImport } from "./routes/_authenticated/user/programs/route";
import { Route as AuthenticatedUserSearchanalyticsRouteImport } from "./routes/_authenticated/user/searchanalytics";
import { Route as AuthenticatedUserSearchqueryperformanceRouteRouteImport } from "./routes/_authenticated/user/searchqueryperformance/route";
import { Route as AuthenticatedUserSettingsRouteImport } from "./routes/_authenticated/user/settings";
import { Route as AuthenticatedUserShopifysummaryRouteImport } from "./routes/_authenticated/user/shopifysummary";
import { Route as AuthenticatedUserShopperinsightsV2RouteImport } from "./routes/_authenticated/user/shopperinsightsV2";
import { Route as AuthenticatedUserTagmanagementRouteImport } from "./routes/_authenticated/user/tagmanagement";
import { Route as AuthenticatedUserTclipRouteRouteImport } from "./routes/_authenticated/user/tclip/route";
import { Route as AuthenticatedUserTicketsRouteImport } from "./routes/_authenticated/user/tickets";
import { Route as AuthenticatedUserTrmnlRouteImport } from "./routes/_authenticated/user/trmnl";
import { Route as AuthenticatedUserUploadsRouteImport } from "./routes/_authenticated/user/uploads";
import { Route as AuthenticatedUserUsermanagementRouteImport } from "./routes/_authenticated/user/usermanagement";
import { Route as AuthenticatedUserVerifyRouteImport } from "./routes/_authenticated/user/verify";
import { Route as AuthenticatedUserVideogenRouteImport } from "./routes/_authenticated/user/videogen";
import { Route as AuthenticatedUserWalmartsummaryRouteImport } from "./routes/_authenticated/user/walmartsummary";
import { Route as AuthenticatedWalmartInstallRouteImport } from "./routes/_authenticated/walmart/install";
import { Route as OauthAmazonAdvertisingRouteImport } from "./routes/oauth/amazon/advertising";
import { Route as OauthAmazonSpapiRouteImport } from "./routes/oauth/amazon/spapi";
import { Route as AuthenticatedOnboardingV2IndexRouteImport } from "./routes/_authenticated/onboarding/v2/index";
import { Route as AuthenticatedOnboardingV2ChannelRouteImport } from "./routes/_authenticated/onboarding/v2/channel";
import { Route as AuthenticatedOnboardingV2ConnectRouteImport } from "./routes/_authenticated/onboarding/v2/connect";
import { Route as AuthenticatedOnboardingV2ProfilesRouteImport } from "./routes/_authenticated/onboarding/v2/profiles";
import { Route as AuthenticatedOnboardingV2SellertypeRouteImport } from "./routes/_authenticated/onboarding/v2/sellertype";
import { Route as AuthenticatedOnboardingV2SummaryRouteImport } from "./routes/_authenticated/onboarding/v2/summary";
import { Route as AuthenticatedUserAdvertisingProgramsRouteRouteImport } from "./routes/_authenticated/user/advertising/programs/route";
import { Route as AuthenticatedUserAdvertisingSettingsRouteImport } from "./routes/_authenticated/user/advertising/settings";
import { Route as AuthenticatedUserAgencyDashboardRouteImport } from "./routes/_authenticated/user/agency/dashboard";
import { Route as AuthenticatedUserAmcConfigurationRouteImport } from "./routes/_authenticated/user/amc/configuration";
import { Route as AuthenticatedUserAmcShopperinsightsV2RouteImport } from "./routes/_authenticated/user/amc/shopperinsightsV2";
import { Route as AuthenticatedUserAppsIndexRouteImport } from "./routes/_authenticated/user/apps/index";
import { Route as AuthenticatedUserAppsShopifyRouteImport } from "./routes/_authenticated/user/apps/shopify";
import { Route as AuthenticatedUserAudienceDashboardRouteImport } from "./routes/_authenticated/user/audience/dashboard";
import { Route as AuthenticatedUserContentSeoRouteImport } from "./routes/_authenticated/user/content/seo";
import { Route as AuthenticatedUserDspIndexRouteImport } from "./routes/_authenticated/user/dsp/index";
import { Route as AuthenticatedUserLiveReportRouteImport } from "./routes/_authenticated/user/live/report";
import { Route as AuthenticatedUserMerchandisingDashboardRouteImport } from "./routes/_authenticated/user/merchandising/dashboard";
import { Route as AuthenticatedUserMerchandisingPromotionsRouteImport } from "./routes/_authenticated/user/merchandising/promotions";
import { Route as AuthenticatedUserPricingIndexRouteImport } from "./routes/_authenticated/user/pricing/index";
import { Route as AuthenticatedUserPricingBuyboxRouteImport } from "./routes/_authenticated/user/pricing/buybox";
import { Route as AuthenticatedUserPricingChangesRouteImport } from "./routes/_authenticated/user/pricing/changes";
import { Route as AuthenticatedUserPricingConfigurationRouteImport } from "./routes/_authenticated/user/pricing/configuration";
import { Route as AuthenticatedUserPricingForecastRouteImport } from "./routes/_authenticated/user/pricing/forecast";
import { Route as AuthenticatedUserProductlaunchIndexRouteImport } from "./routes/_authenticated/user/productlaunch/index";
import { Route as AuthenticatedUserProductlaunchNewRouteImport } from "./routes/_authenticated/user/productlaunch/new";
import { Route as AuthenticatedUserProgramsIndexRouteImport } from "./routes/_authenticated/user/programs/index";
import { Route as AuthenticatedUserProgramsCreateRouteImport } from "./routes/_authenticated/user/programs/create";
import { Route as AuthenticatedUserReportAdvertisementRouteImport } from "./routes/_authenticated/user/report/advertisement";
import { Route as AuthenticatedUserReportAudienceRouteImport } from "./routes/_authenticated/user/report/audience";
import { Route as AuthenticatedUserReportExportRouteImport } from "./routes/_authenticated/user/report/export";
import { Route as AuthenticatedUserReportPricing_planRouteImport } from "./routes/_authenticated/user/report/pricing_plan";
import { Route as AuthenticatedUserReportProductRouteImport } from "./routes/_authenticated/user/report/product";
import { Route as AuthenticatedUserReportProduct_adRouteImport } from "./routes/_authenticated/user/report/product_ad";
import { Route as AuthenticatedUserReportSqpr_reportRouteImport } from "./routes/_authenticated/user/report/sqpr_report";
import { Route as AuthenticatedUserReportStr_reportRouteImport } from "./routes/_authenticated/user/report/str_report";
import { Route as AuthenticatedUserReportTargetRouteImport } from "./routes/_authenticated/user/report/target";
import { Route as AuthenticatedUserSearchqueryperformanceIndexRouteImport } from "./routes/_authenticated/user/searchqueryperformance/index";
import { Route as AuthenticatedUserSearchqueryperformanceIdRouteImport } from "./routes/_authenticated/user/searchqueryperformance/$id";
import { Route as AuthenticatedUserStaffDashboardRouteImport } from "./routes/_authenticated/user/staff/dashboard";
import { Route as AuthenticatedUserStaffReportcardRouteRouteImport } from "./routes/_authenticated/user/staff/reportcard/route";
import { Route as AuthenticatedUserStaffUserActivityRouteRouteImport } from "./routes/_authenticated/user/staff/user-activity/route";
import { Route as AuthenticatedUserStaffWorkflowsRouteRouteImport } from "./routes/_authenticated/user/staff/workflows/route";
import { Route as AuthenticatedUserTclipAgentsRouteImport } from "./routes/_authenticated/user/tclip/agents";
import { Route as AuthenticatedUserTclipTasksRouteImport } from "./routes/_authenticated/user/tclip/tasks";
import { Route as AuthenticatedUserUserdetailsIdRouteImport } from "./routes/_authenticated/user/userdetails/$id";
import { Route as PdfReportOrganizationSummaryRouteImport } from "./routes/pdf/report/organization/summary";
import { Route as AuthenticatedOnboardingV2AboutSalesRouteImport } from "./routes/_authenticated/onboarding/v2/about/sales";
import { Route as AuthenticatedOnboardingV2AboutTypeRouteImport } from "./routes/_authenticated/onboarding/v2/about/type";
import { Route as AuthenticatedUserAdvertisingDashboardIndexRouteImport } from "./routes/_authenticated/user/advertising/dashboard/index";
import { Route as AuthenticatedUserAdvertisingProgramsIndexRouteImport } from "./routes/_authenticated/user/advertising/programs/index";
import { Route as AuthenticatedUserAdvertisingProgramsCreateRouteImport } from "./routes/_authenticated/user/advertising/programs/create";
import { Route as AuthenticatedUserAmcConversionchartReportsRouteImport } from "./routes/_authenticated/user/amc/conversionchart/reports";
import { Route as AuthenticatedUserAmcDashboardIndexRouteImport } from "./routes/_authenticated/user/amc/dashboard/index";
import { Route as AuthenticatedUserContentQualityOrgRouteImport } from "./routes/_authenticated/user/content/quality/org";
import { Route as AuthenticatedUserContentTemplatesTemplateIdRouteImport } from "./routes/_authenticated/user/content/templates/$templateId";
import { Route as AuthenticatedUserDspDspAdvertiserDashboardRouteImport } from "./routes/_authenticated/user/dsp/$dspAdvertiser/dashboard";
import { Route as AuthenticatedUserMerchandisingCategoryCategoryRouteImport } from "./routes/_authenticated/user/merchandising/category/$category";
import { Route as AuthenticatedUserMerchandisingCouponsIndexRouteImport } from "./routes/_authenticated/user/merchandising/coupons/index";
import { Route as AuthenticatedUserMerchandisingCouponsCouponRouteImport } from "./routes/_authenticated/user/merchandising/coupons/$coupon";
import { Route as AuthenticatedUserMerchandisingParentParentAsinRouteImport } from "./routes/_authenticated/user/merchandising/parent/$parentAsin";
import { Route as AuthenticatedUserMerchandisingProductProductRouteImport } from "./routes/_authenticated/user/merchandising/product/$product";
import { Route as AuthenticatedUserPlReportIndexRouteImport } from "./routes/_authenticated/user/pl/report/index";
import { Route as AuthenticatedUserPricingDashboardIndexRouteImport } from "./routes/_authenticated/user/pricing/dashboard/index";
import { Route as AuthenticatedUserPricingManagementIndexRouteImport } from "./routes/_authenticated/user/pricing/management/index";
import { Route as AuthenticatedUserPricingPlanPlanRouteImport } from "./routes/_authenticated/user/pricing/plan/$plan";
import { Route as AuthenticatedUserProductlaunchLaunchesIdRouteImport } from "./routes/_authenticated/user/productlaunch/launches/$id";
import { Route as AuthenticatedUserProgramsEditIdRouteImport } from "./routes/_authenticated/user/programs/edit/$id";
import { Route as AuthenticatedUserReportOrganizationSummaryRouteImport } from "./routes/_authenticated/user/report/organization/summary";
import { Route as AuthenticatedUserStaffReportcardIndexRouteImport } from "./routes/_authenticated/user/staff/reportcard/index";
import { Route as AuthenticatedUserStaffReportcardOrg_idRouteImport } from "./routes/_authenticated/user/staff/reportcard/$org_id";
import { Route as AuthenticatedUserStaffUserActivityIndexRouteImport } from "./routes/_authenticated/user/staff/user-activity/index";
import { Route as AuthenticatedUserStaffUserActivityOrg_idRouteImport } from "./routes/_authenticated/user/staff/user-activity/$org_id";
import { Route as AuthenticatedUserStaffWalmartProfilesRouteImport } from "./routes/_authenticated/user/staff/walmart/profiles";
import { Route as AuthenticatedUserStaffWorkflowsIndexRouteImport } from "./routes/_authenticated/user/staff/workflows/index";
import { Route as AuthenticatedUserStaffWorkflowsWorkflow_idRouteImport } from "./routes/_authenticated/user/staff/workflows/$workflow_id";
import { Route as AuthenticatedUserAdvertisingDashboardAdsIdRouteImport } from "./routes/_authenticated/user/advertising/dashboard/ads/$id";
import { Route as AuthenticatedUserAdvertisingDashboardCategoryIdRouteImport } from "./routes/_authenticated/user/advertising/dashboard/category/$id";
import { Route as AuthenticatedUserAdvertisingProgramsEditIdRouteImport } from "./routes/_authenticated/user/advertising/programs/edit/$id";
import { Route as AuthenticatedUserAmcDashboardReportsIdRouteImport } from "./routes/_authenticated/user/amc/dashboard/reports/$id";
import { Route as AuthenticatedUserContentQualityCategoryCategoryRouteImport } from "./routes/_authenticated/user/content/quality/category/$category";
import { Route as AuthenticatedUserDspDspAdvertiserLineitemsIdRouteImport } from "./routes/_authenticated/user/dsp/$dspAdvertiser/lineitems/$id";
import { Route as AuthenticatedUserDspDspAdvertiserOrdersIdRouteImport } from "./routes/_authenticated/user/dsp/$dspAdvertiser/orders/$id";
import { Route as AuthenticatedUserPricingDashboardCategoryCategoryRouteImport } from "./routes/_authenticated/user/pricing/dashboard/category/$category";
import { Route as AuthenticatedUserPricingManagementCategoryCategoryRouteImport } from "./routes/_authenticated/user/pricing/management/category/$category";
import { Route as AuthenticatedUserAmcDashboardReportsDetailsIdRouteImport } from "./routes/_authenticated/user/amc/dashboard/reports/details/$id";

const AuthenticatedUserTclipPlaygroundLazyRouteImport = createFileRoute(
  "/_authenticated/user/tclip/playground",
)();
const AuthenticatedUserTclipTemplatesLazyRouteImport = createFileRoute(
  "/_authenticated/user/tclip/templates",
)();
const AuthenticatedUserTclipTranscriptsLazyRouteImport = createFileRoute(
  "/_authenticated/user/tclip/transcripts",
)();
const AuthenticatedUserTclipAgentAgentIdLazyRouteImport = createFileRoute(
  "/_authenticated/user/tclip/agent/$agentId",
)();

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const PdfRouteRoute = PdfRouteRouteImport.update({
  id: "/pdf",
  path: "/pdf",
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedUserRouteRoute = AuthenticatedUserRouteRouteImport.update({
  id: "/user",
  path: "/user",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const ConnectTiktokRoute = ConnectTiktokRouteImport.update({
  id: "/connect/tiktok",
  path: "/connect/tiktok",
  getParentRoute: () => rootRouteImport,
} as any);
const ShopifyInstallRoute = ShopifyInstallRouteImport.update({
  id: "/shopify/install",
  path: "/shopify/install",
  getParentRoute: () => rootRouteImport,
} as any);
const SigninIndexRoute = SigninIndexRouteImport.update({
  id: "/signin/",
  path: "/signin/",
  getParentRoute: () => rootRouteImport,
} as any);
const SigninResetpasswordRoute = SigninResetpasswordRouteImport.update({
  id: "/signin/resetpassword",
  path: "/signin/resetpassword",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedMcpAuthorizeRoute =
  AuthenticatedMcpAuthorizeRouteImport.update({
    id: "/mcp/authorize",
    path: "/mcp/authorize",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedOnboardingV2RouteRoute =
  AuthenticatedOnboardingV2RouteRouteImport.update({
    id: "/onboarding/v2",
    path: "/onboarding/v2",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedUserIndexRoute = AuthenticatedUserIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserAmzsummaryRoute =
  AuthenticatedUserAmzsummaryRouteImport.update({
    id: "/amzsummary",
    path: "/amzsummary",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserApplicationsRoute =
  AuthenticatedUserApplicationsRouteImport.update({
    id: "/applications",
    path: "/applications",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/user/applications.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedUserBillingRoute =
  AuthenticatedUserBillingRouteImport.update({
    id: "/billing",
    path: "/billing",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserCategorymanagementRoute =
  AuthenticatedUserCategorymanagementRouteImport.update({
    id: "/categorymanagement",
    path: "/categorymanagement",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserChromeaccessRoute =
  AuthenticatedUserChromeaccessRouteImport.update({
    id: "/chromeaccess",
    path: "/chromeaccess",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDashboardRoute =
  AuthenticatedUserDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDataStatusRoute =
  AuthenticatedUserDataStatusRouteImport.update({
    id: "/data-status",
    path: "/data-status",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserGoalsRoute = AuthenticatedUserGoalsRouteImport.update({
  id: "/goals",
  path: "/goals",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserLiveRouteRoute =
  AuthenticatedUserLiveRouteRouteImport.update({
    id: "/live",
    path: "/live",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserMcpRoute = AuthenticatedUserMcpRouteImport.update({
  id: "/mcp",
  path: "/mcp",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserMerchandisingRouteRoute =
  AuthenticatedUserMerchandisingRouteRouteImport.update({
    id: "/merchandising",
    path: "/merchandising",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserPaymentRoute =
  AuthenticatedUserPaymentRouteImport.update({
    id: "/payment",
    path: "/payment",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserPlRouteRoute =
  AuthenticatedUserPlRouteRouteImport.update({
    id: "/pl",
    path: "/pl",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserPlansRoute = AuthenticatedUserPlansRouteImport.update({
  id: "/plans",
  path: "/plans",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserPricingRouteRoute =
  AuthenticatedUserPricingRouteRouteImport.update({
    id: "/pricing",
    path: "/pricing",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserProductlaunchRouteRoute =
  AuthenticatedUserProductlaunchRouteRouteImport.update({
    id: "/productlaunch",
    path: "/productlaunch",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserProgramsRouteRoute =
  AuthenticatedUserProgramsRouteRouteImport.update({
    id: "/programs",
    path: "/programs",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserSearchanalyticsRoute =
  AuthenticatedUserSearchanalyticsRouteImport.update({
    id: "/searchanalytics",
    path: "/searchanalytics",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserSearchqueryperformanceRouteRoute =
  AuthenticatedUserSearchqueryperformanceRouteRouteImport.update({
    id: "/searchqueryperformance",
    path: "/searchqueryperformance",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserSettingsRoute =
  AuthenticatedUserSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserShopifysummaryRoute =
  AuthenticatedUserShopifysummaryRouteImport.update({
    id: "/shopifysummary",
    path: "/shopifysummary",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserShopperinsightsV2Route =
  AuthenticatedUserShopperinsightsV2RouteImport.update({
    id: "/shopperinsightsV2",
    path: "/shopperinsightsV2",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserTagmanagementRoute =
  AuthenticatedUserTagmanagementRouteImport.update({
    id: "/tagmanagement",
    path: "/tagmanagement",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserTclipRouteRoute =
  AuthenticatedUserTclipRouteRouteImport.update({
    id: "/tclip",
    path: "/tclip",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserTicketsRoute =
  AuthenticatedUserTicketsRouteImport.update({
    id: "/tickets",
    path: "/tickets",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserTrmnlRoute = AuthenticatedUserTrmnlRouteImport.update({
  id: "/trmnl",
  path: "/trmnl",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserUploadsRoute =
  AuthenticatedUserUploadsRouteImport.update({
    id: "/uploads",
    path: "/uploads",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserUsermanagementRoute =
  AuthenticatedUserUsermanagementRouteImport.update({
    id: "/usermanagement",
    path: "/usermanagement",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserVerifyRoute = AuthenticatedUserVerifyRouteImport.update({
  id: "/verify",
  path: "/verify",
  getParentRoute: () => AuthenticatedUserRouteRoute,
} as any);
const AuthenticatedUserVideogenRoute =
  AuthenticatedUserVideogenRouteImport.update({
    id: "/videogen",
    path: "/videogen",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserWalmartsummaryRoute =
  AuthenticatedUserWalmartsummaryRouteImport.update({
    id: "/walmartsummary",
    path: "/walmartsummary",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedWalmartInstallRoute =
  AuthenticatedWalmartInstallRouteImport.update({
    id: "/walmart/install",
    path: "/walmart/install",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const OauthAmazonAdvertisingRoute = OauthAmazonAdvertisingRouteImport.update({
  id: "/oauth/amazon/advertising",
  path: "/oauth/amazon/advertising",
  getParentRoute: () => rootRouteImport,
} as any);
const OauthAmazonSpapiRoute = OauthAmazonSpapiRouteImport.update({
  id: "/oauth/amazon/spapi",
  path: "/oauth/amazon/spapi",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedOnboardingV2IndexRoute =
  AuthenticatedOnboardingV2IndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2ChannelRoute =
  AuthenticatedOnboardingV2ChannelRouteImport.update({
    id: "/channel",
    path: "/channel",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2ConnectRoute =
  AuthenticatedOnboardingV2ConnectRouteImport.update({
    id: "/connect",
    path: "/connect",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2ProfilesRoute =
  AuthenticatedOnboardingV2ProfilesRouteImport.update({
    id: "/profiles",
    path: "/profiles",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2SellertypeRoute =
  AuthenticatedOnboardingV2SellertypeRouteImport.update({
    id: "/sellertype",
    path: "/sellertype",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2SummaryRoute =
  AuthenticatedOnboardingV2SummaryRouteImport.update({
    id: "/summary",
    path: "/summary",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedUserAdvertisingProgramsRouteRoute =
  AuthenticatedUserAdvertisingProgramsRouteRouteImport.update({
    id: "/advertising/programs",
    path: "/advertising/programs",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAdvertisingSettingsRoute =
  AuthenticatedUserAdvertisingSettingsRouteImport.update({
    id: "/advertising/settings",
    path: "/advertising/settings",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAgencyDashboardRoute =
  AuthenticatedUserAgencyDashboardRouteImport.update({
    id: "/agency/dashboard",
    path: "/agency/dashboard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAmcConfigurationRoute =
  AuthenticatedUserAmcConfigurationRouteImport.update({
    id: "/amc/configuration",
    path: "/amc/configuration",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAmcShopperinsightsV2Route =
  AuthenticatedUserAmcShopperinsightsV2RouteImport.update({
    id: "/amc/shopperinsightsV2",
    path: "/amc/shopperinsightsV2",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAppsIndexRoute =
  AuthenticatedUserAppsIndexRouteImport.update({
    id: "/apps/",
    path: "/apps/",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAppsShopifyRoute =
  AuthenticatedUserAppsShopifyRouteImport.update({
    id: "/apps/shopify",
    path: "/apps/shopify",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAudienceDashboardRoute =
  AuthenticatedUserAudienceDashboardRouteImport.update({
    id: "/audience/dashboard",
    path: "/audience/dashboard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserContentSeoRoute =
  AuthenticatedUserContentSeoRouteImport.update({
    id: "/content/seo",
    path: "/content/seo",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDspIndexRoute =
  AuthenticatedUserDspIndexRouteImport.update({
    id: "/dsp/",
    path: "/dsp/",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserLiveReportRoute =
  AuthenticatedUserLiveReportRouteImport.update({
    id: "/report",
    path: "/report",
    getParentRoute: () => AuthenticatedUserLiveRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingDashboardRoute =
  AuthenticatedUserMerchandisingDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingPromotionsRoute =
  AuthenticatedUserMerchandisingPromotionsRouteImport.update({
    id: "/promotions",
    path: "/promotions",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserPricingIndexRoute =
  AuthenticatedUserPricingIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingBuyboxRoute =
  AuthenticatedUserPricingBuyboxRouteImport.update({
    id: "/buybox",
    path: "/buybox",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingChangesRoute =
  AuthenticatedUserPricingChangesRouteImport.update({
    id: "/changes",
    path: "/changes",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingConfigurationRoute =
  AuthenticatedUserPricingConfigurationRouteImport.update({
    id: "/configuration",
    path: "/configuration",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingForecastRoute =
  AuthenticatedUserPricingForecastRouteImport.update({
    id: "/forecast",
    path: "/forecast",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserProductlaunchIndexRoute =
  AuthenticatedUserProductlaunchIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserProductlaunchRouteRoute,
  } as any);
const AuthenticatedUserProductlaunchNewRoute =
  AuthenticatedUserProductlaunchNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => AuthenticatedUserProductlaunchRouteRoute,
  } as any);
const AuthenticatedUserProgramsIndexRoute =
  AuthenticatedUserProgramsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserProgramsRouteRoute,
  } as any);
const AuthenticatedUserProgramsCreateRoute =
  AuthenticatedUserProgramsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedUserProgramsRouteRoute,
  } as any);
const AuthenticatedUserReportAdvertisementRoute =
  AuthenticatedUserReportAdvertisementRouteImport.update({
    id: "/report/advertisement",
    path: "/report/advertisement",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportAudienceRoute =
  AuthenticatedUserReportAudienceRouteImport.update({
    id: "/report/audience",
    path: "/report/audience",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportExportRoute =
  AuthenticatedUserReportExportRouteImport.update({
    id: "/report/export",
    path: "/report/export",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportPricing_planRoute =
  AuthenticatedUserReportPricing_planRouteImport.update({
    id: "/report/pricing_plan",
    path: "/report/pricing_plan",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportProductRoute =
  AuthenticatedUserReportProductRouteImport.update({
    id: "/report/product",
    path: "/report/product",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportProduct_adRoute =
  AuthenticatedUserReportProduct_adRouteImport.update({
    id: "/report/product_ad",
    path: "/report/product_ad",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportSqpr_reportRoute =
  AuthenticatedUserReportSqpr_reportRouteImport.update({
    id: "/report/sqpr_report",
    path: "/report/sqpr_report",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportStr_reportRoute =
  AuthenticatedUserReportStr_reportRouteImport.update({
    id: "/report/str_report",
    path: "/report/str_report",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserReportTargetRoute =
  AuthenticatedUserReportTargetRouteImport.update({
    id: "/report/target",
    path: "/report/target",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserSearchqueryperformanceIndexRoute =
  AuthenticatedUserSearchqueryperformanceIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserSearchqueryperformanceRouteRoute,
  } as any);
const AuthenticatedUserSearchqueryperformanceIdRoute =
  AuthenticatedUserSearchqueryperformanceIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => AuthenticatedUserSearchqueryperformanceRouteRoute,
  } as any);
const AuthenticatedUserStaffDashboardRoute =
  AuthenticatedUserStaffDashboardRouteImport.update({
    id: "/staff/dashboard",
    path: "/staff/dashboard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserStaffReportcardRouteRoute =
  AuthenticatedUserStaffReportcardRouteRouteImport.update({
    id: "/staff/reportcard",
    path: "/staff/reportcard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserStaffUserActivityRouteRoute =
  AuthenticatedUserStaffUserActivityRouteRouteImport.update({
    id: "/staff/user-activity",
    path: "/staff/user-activity",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserStaffWorkflowsRouteRoute =
  AuthenticatedUserStaffWorkflowsRouteRouteImport.update({
    id: "/staff/workflows",
    path: "/staff/workflows",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserTclipAgentsRoute =
  AuthenticatedUserTclipAgentsRouteImport.update({
    id: "/agents",
    path: "/agents",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any);
const AuthenticatedUserTclipPlaygroundLazyRoute =
  AuthenticatedUserTclipPlaygroundLazyRouteImport.update({
    id: "/playground",
    path: "/playground",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/user/tclip/playground.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedUserTclipTasksRoute =
  AuthenticatedUserTclipTasksRouteImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any);
const AuthenticatedUserTclipTemplatesLazyRoute =
  AuthenticatedUserTclipTemplatesLazyRouteImport.update({
    id: "/templates",
    path: "/templates",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/user/tclip/templates.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedUserTclipTranscriptsLazyRoute =
  AuthenticatedUserTclipTranscriptsLazyRouteImport.update({
    id: "/transcripts",
    path: "/transcripts",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/user/tclip/transcripts.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedUserUserdetailsIdRoute =
  AuthenticatedUserUserdetailsIdRouteImport.update({
    id: "/userdetails/$id",
    path: "/userdetails/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const PdfReportOrganizationSummaryRoute =
  PdfReportOrganizationSummaryRouteImport.update({
    id: "/report/organization/summary",
    path: "/report/organization/summary",
    getParentRoute: () => PdfRouteRoute,
  } as any);
const AuthenticatedOnboardingV2AboutSalesRoute =
  AuthenticatedOnboardingV2AboutSalesRouteImport.update({
    id: "/about/sales",
    path: "/about/sales",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedOnboardingV2AboutTypeRoute =
  AuthenticatedOnboardingV2AboutTypeRouteImport.update({
    id: "/about/type",
    path: "/about/type",
    getParentRoute: () => AuthenticatedOnboardingV2RouteRoute,
  } as any);
const AuthenticatedUserAdvertisingDashboardIndexRoute =
  AuthenticatedUserAdvertisingDashboardIndexRouteImport.update({
    id: "/advertising/dashboard/",
    path: "/advertising/dashboard/",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAdvertisingProgramsIndexRoute =
  AuthenticatedUserAdvertisingProgramsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserAdvertisingProgramsRouteRoute,
  } as any);
const AuthenticatedUserAdvertisingProgramsCreateRoute =
  AuthenticatedUserAdvertisingProgramsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedUserAdvertisingProgramsRouteRoute,
  } as any);
const AuthenticatedUserAmcConversionchartReportsRoute =
  AuthenticatedUserAmcConversionchartReportsRouteImport.update({
    id: "/amc/conversionchart/reports",
    path: "/amc/conversionchart/reports",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAmcDashboardIndexRoute =
  AuthenticatedUserAmcDashboardIndexRouteImport.update({
    id: "/amc/dashboard/",
    path: "/amc/dashboard/",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserContentQualityOrgRoute =
  AuthenticatedUserContentQualityOrgRouteImport.update({
    id: "/content/quality/org",
    path: "/content/quality/org",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserContentTemplatesTemplateIdRoute =
  AuthenticatedUserContentTemplatesTemplateIdRouteImport.update({
    id: "/content/templates/$templateId",
    path: "/content/templates/$templateId",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDspDspAdvertiserDashboardRoute =
  AuthenticatedUserDspDspAdvertiserDashboardRouteImport.update({
    id: "/dsp/$dspAdvertiser/dashboard",
    path: "/dsp/$dspAdvertiser/dashboard",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingCategoryCategoryRoute =
  AuthenticatedUserMerchandisingCategoryCategoryRouteImport.update({
    id: "/category/$category",
    path: "/category/$category",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingCouponsIndexRoute =
  AuthenticatedUserMerchandisingCouponsIndexRouteImport.update({
    id: "/coupons/",
    path: "/coupons/",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingCouponsCouponRoute =
  AuthenticatedUserMerchandisingCouponsCouponRouteImport.update({
    id: "/coupons/$coupon",
    path: "/coupons/$coupon",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingParentParentAsinRoute =
  AuthenticatedUserMerchandisingParentParentAsinRouteImport.update({
    id: "/parent/$parentAsin",
    path: "/parent/$parentAsin",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserMerchandisingProductProductRoute =
  AuthenticatedUserMerchandisingProductProductRouteImport.update({
    id: "/product/$product",
    path: "/product/$product",
    getParentRoute: () => AuthenticatedUserMerchandisingRouteRoute,
  } as any);
const AuthenticatedUserPlReportIndexRoute =
  AuthenticatedUserPlReportIndexRouteImport.update({
    id: "/report/",
    path: "/report/",
    getParentRoute: () => AuthenticatedUserPlRouteRoute,
  } as any);
const AuthenticatedUserPricingDashboardIndexRoute =
  AuthenticatedUserPricingDashboardIndexRouteImport.update({
    id: "/dashboard/",
    path: "/dashboard/",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingManagementIndexRoute =
  AuthenticatedUserPricingManagementIndexRouteImport.update({
    id: "/management/",
    path: "/management/",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingPlanPlanRoute =
  AuthenticatedUserPricingPlanPlanRouteImport.update({
    id: "/plan/$plan",
    path: "/plan/$plan",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserProductlaunchLaunchesIdRoute =
  AuthenticatedUserProductlaunchLaunchesIdRouteImport.update({
    id: "/launches/$id",
    path: "/launches/$id",
    getParentRoute: () => AuthenticatedUserProductlaunchRouteRoute,
  } as any);
const AuthenticatedUserProgramsEditIdRoute =
  AuthenticatedUserProgramsEditIdRouteImport.update({
    id: "/edit/$id",
    path: "/edit/$id",
    getParentRoute: () => AuthenticatedUserProgramsRouteRoute,
  } as any);
const AuthenticatedUserReportOrganizationSummaryRoute =
  AuthenticatedUserReportOrganizationSummaryRouteImport.update({
    id: "/report/organization/summary",
    path: "/report/organization/summary",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserStaffReportcardIndexRoute =
  AuthenticatedUserStaffReportcardIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserStaffReportcardRouteRoute,
  } as any);
const AuthenticatedUserStaffReportcardOrg_idRoute =
  AuthenticatedUserStaffReportcardOrg_idRouteImport.update({
    id: "/$org_id",
    path: "/$org_id",
    getParentRoute: () => AuthenticatedUserStaffReportcardRouteRoute,
  } as any);
const AuthenticatedUserStaffUserActivityIndexRoute =
  AuthenticatedUserStaffUserActivityIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserStaffUserActivityRouteRoute,
  } as any);
const AuthenticatedUserStaffUserActivityOrg_idRoute =
  AuthenticatedUserStaffUserActivityOrg_idRouteImport.update({
    id: "/$org_id",
    path: "/$org_id",
    getParentRoute: () => AuthenticatedUserStaffUserActivityRouteRoute,
  } as any);
const AuthenticatedUserStaffWalmartProfilesRoute =
  AuthenticatedUserStaffWalmartProfilesRouteImport.update({
    id: "/staff/walmart/profiles",
    path: "/staff/walmart/profiles",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserStaffWorkflowsIndexRoute =
  AuthenticatedUserStaffWorkflowsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedUserStaffWorkflowsRouteRoute,
  } as any);
const AuthenticatedUserStaffWorkflowsWorkflow_idRoute =
  AuthenticatedUserStaffWorkflowsWorkflow_idRouteImport.update({
    id: "/$workflow_id",
    path: "/$workflow_id",
    getParentRoute: () => AuthenticatedUserStaffWorkflowsRouteRoute,
  } as any);
const AuthenticatedUserTclipAgentAgentIdLazyRoute =
  AuthenticatedUserTclipAgentAgentIdLazyRouteImport.update({
    id: "/agent/$agentId",
    path: "/agent/$agentId",
    getParentRoute: () => AuthenticatedUserTclipRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/user/tclip/agent/$agentId.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedUserAdvertisingDashboardAdsIdRoute =
  AuthenticatedUserAdvertisingDashboardAdsIdRouteImport.update({
    id: "/advertising/dashboard/ads/$id",
    path: "/advertising/dashboard/ads/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAdvertisingDashboardCategoryIdRoute =
  AuthenticatedUserAdvertisingDashboardCategoryIdRouteImport.update({
    id: "/advertising/dashboard/category/$id",
    path: "/advertising/dashboard/category/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserAdvertisingProgramsEditIdRoute =
  AuthenticatedUserAdvertisingProgramsEditIdRouteImport.update({
    id: "/edit/$id",
    path: "/edit/$id",
    getParentRoute: () => AuthenticatedUserAdvertisingProgramsRouteRoute,
  } as any);
const AuthenticatedUserAmcDashboardReportsIdRoute =
  AuthenticatedUserAmcDashboardReportsIdRouteImport.update({
    id: "/amc/dashboard/reports/$id",
    path: "/amc/dashboard/reports/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserContentQualityCategoryCategoryRoute =
  AuthenticatedUserContentQualityCategoryCategoryRouteImport.update({
    id: "/content/quality/category/$category",
    path: "/content/quality/category/$category",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDspDspAdvertiserLineitemsIdRoute =
  AuthenticatedUserDspDspAdvertiserLineitemsIdRouteImport.update({
    id: "/dsp/$dspAdvertiser/lineitems/$id",
    path: "/dsp/$dspAdvertiser/lineitems/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserDspDspAdvertiserOrdersIdRoute =
  AuthenticatedUserDspDspAdvertiserOrdersIdRouteImport.update({
    id: "/dsp/$dspAdvertiser/orders/$id",
    path: "/dsp/$dspAdvertiser/orders/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);
const AuthenticatedUserPricingDashboardCategoryCategoryRoute =
  AuthenticatedUserPricingDashboardCategoryCategoryRouteImport.update({
    id: "/dashboard/category/$category",
    path: "/dashboard/category/$category",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserPricingManagementCategoryCategoryRoute =
  AuthenticatedUserPricingManagementCategoryCategoryRouteImport.update({
    id: "/management/category/$category",
    path: "/management/category/$category",
    getParentRoute: () => AuthenticatedUserPricingRouteRoute,
  } as any);
const AuthenticatedUserAmcDashboardReportsDetailsIdRoute =
  AuthenticatedUserAmcDashboardReportsDetailsIdRouteImport.update({
    id: "/amc/dashboard/reports/details/$id",
    path: "/amc/dashboard/reports/details/$id",
    getParentRoute: () => AuthenticatedUserRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/pdf": typeof PdfRouteRouteWithChildren;
  "/signup": typeof SignupRoute;
  "/user": typeof AuthenticatedUserRouteRouteWithChildren;
  "/connect/tiktok": typeof ConnectTiktokRoute;
  "/shopify/install": typeof ShopifyInstallRoute;
  "/signin/resetpassword": typeof SigninResetpasswordRoute;
  "/signin/": typeof SigninIndexRoute;
  "/onboarding/v2": typeof AuthenticatedOnboardingV2RouteRouteWithChildren;
  "/user/live": typeof AuthenticatedUserLiveRouteRouteWithChildren;
  "/user/merchandising": typeof AuthenticatedUserMerchandisingRouteRouteWithChildren;
  "/user/pl": typeof AuthenticatedUserPlRouteRouteWithChildren;
  "/user/pricing": typeof AuthenticatedUserPricingRouteRouteWithChildren;
  "/user/productlaunch": typeof AuthenticatedUserProductlaunchRouteRouteWithChildren;
  "/user/programs": typeof AuthenticatedUserProgramsRouteRouteWithChildren;
  "/user/searchqueryperformance": typeof AuthenticatedUserSearchqueryperformanceRouteRouteWithChildren;
  "/user/tclip": typeof AuthenticatedUserTclipRouteRouteWithChildren;
  "/mcp/authorize": typeof AuthenticatedMcpAuthorizeRoute;
  "/user/amzsummary": typeof AuthenticatedUserAmzsummaryRoute;
  "/user/applications": typeof AuthenticatedUserApplicationsRoute;
  "/user/billing": typeof AuthenticatedUserBillingRoute;
  "/user/categorymanagement": typeof AuthenticatedUserCategorymanagementRoute;
  "/user/chromeaccess": typeof AuthenticatedUserChromeaccessRoute;
  "/user/dashboard": typeof AuthenticatedUserDashboardRoute;
  "/user/data-status": typeof AuthenticatedUserDataStatusRoute;
  "/user/goals": typeof AuthenticatedUserGoalsRoute;
  "/user/mcp": typeof AuthenticatedUserMcpRoute;
  "/user/payment": typeof AuthenticatedUserPaymentRoute;
  "/user/plans": typeof AuthenticatedUserPlansRoute;
  "/user/searchanalytics": typeof AuthenticatedUserSearchanalyticsRoute;
  "/user/settings": typeof AuthenticatedUserSettingsRoute;
  "/user/shopifysummary": typeof AuthenticatedUserShopifysummaryRoute;
  "/user/shopperinsightsV2": typeof AuthenticatedUserShopperinsightsV2Route;
  "/user/tagmanagement": typeof AuthenticatedUserTagmanagementRoute;
  "/user/tickets": typeof AuthenticatedUserTicketsRoute;
  "/user/trmnl": typeof AuthenticatedUserTrmnlRoute;
  "/user/uploads": typeof AuthenticatedUserUploadsRoute;
  "/user/usermanagement": typeof AuthenticatedUserUsermanagementRoute;
  "/user/verify": typeof AuthenticatedUserVerifyRoute;
  "/user/videogen": typeof AuthenticatedUserVideogenRoute;
  "/user/walmartsummary": typeof AuthenticatedUserWalmartsummaryRoute;
  "/walmart/install": typeof AuthenticatedWalmartInstallRoute;
  "/oauth/amazon/advertising": typeof OauthAmazonAdvertisingRoute;
  "/oauth/amazon/spapi": typeof OauthAmazonSpapiRoute;
  "/user/": typeof AuthenticatedUserIndexRoute;
  "/user/advertising/programs": typeof AuthenticatedUserAdvertisingProgramsRouteRouteWithChildren;
  "/user/staff/reportcard": typeof AuthenticatedUserStaffReportcardRouteRouteWithChildren;
  "/user/staff/user-activity": typeof AuthenticatedUserStaffUserActivityRouteRouteWithChildren;
  "/user/staff/workflows": typeof AuthenticatedUserStaffWorkflowsRouteRouteWithChildren;
  "/onboarding/v2/channel": typeof AuthenticatedOnboardingV2ChannelRoute;
  "/onboarding/v2/connect": typeof AuthenticatedOnboardingV2ConnectRoute;
  "/onboarding/v2/profiles": typeof AuthenticatedOnboardingV2ProfilesRoute;
  "/onboarding/v2/sellertype": typeof AuthenticatedOnboardingV2SellertypeRoute;
  "/onboarding/v2/summary": typeof AuthenticatedOnboardingV2SummaryRoute;
  "/user/advertising/settings": typeof AuthenticatedUserAdvertisingSettingsRoute;
  "/user/agency/dashboard": typeof AuthenticatedUserAgencyDashboardRoute;
  "/user/amc/configuration": typeof AuthenticatedUserAmcConfigurationRoute;
  "/user/amc/shopperinsightsV2": typeof AuthenticatedUserAmcShopperinsightsV2Route;
  "/user/apps/shopify": typeof AuthenticatedUserAppsShopifyRoute;
  "/user/audience/dashboard": typeof AuthenticatedUserAudienceDashboardRoute;
  "/user/content/seo": typeof AuthenticatedUserContentSeoRoute;
  "/user/live/report": typeof AuthenticatedUserLiveReportRoute;
  "/user/merchandising/dashboard": typeof AuthenticatedUserMerchandisingDashboardRoute;
  "/user/merchandising/promotions": typeof AuthenticatedUserMerchandisingPromotionsRoute;
  "/user/pricing/buybox": typeof AuthenticatedUserPricingBuyboxRoute;
  "/user/pricing/changes": typeof AuthenticatedUserPricingChangesRoute;
  "/user/pricing/configuration": typeof AuthenticatedUserPricingConfigurationRoute;
  "/user/pricing/forecast": typeof AuthenticatedUserPricingForecastRoute;
  "/user/productlaunch/new": typeof AuthenticatedUserProductlaunchNewRoute;
  "/user/programs/create": typeof AuthenticatedUserProgramsCreateRoute;
  "/user/report/advertisement": typeof AuthenticatedUserReportAdvertisementRoute;
  "/user/report/audience": typeof AuthenticatedUserReportAudienceRoute;
  "/user/report/export": typeof AuthenticatedUserReportExportRoute;
  "/user/report/pricing_plan": typeof AuthenticatedUserReportPricing_planRoute;
  "/user/report/product": typeof AuthenticatedUserReportProductRoute;
  "/user/report/product_ad": typeof AuthenticatedUserReportProduct_adRoute;
  "/user/report/sqpr_report": typeof AuthenticatedUserReportSqpr_reportRoute;
  "/user/report/str_report": typeof AuthenticatedUserReportStr_reportRoute;
  "/user/report/target": typeof AuthenticatedUserReportTargetRoute;
  "/user/searchqueryperformance/$id": typeof AuthenticatedUserSearchqueryperformanceIdRoute;
  "/user/staff/dashboard": typeof AuthenticatedUserStaffDashboardRoute;
  "/user/tclip/agents": typeof AuthenticatedUserTclipAgentsRoute;
  "/user/tclip/tasks": typeof AuthenticatedUserTclipTasksRoute;
  "/user/userdetails/$id": typeof AuthenticatedUserUserdetailsIdRoute;
  "/pdf/report/organization/summary": typeof PdfReportOrganizationSummaryRoute;
  "/user/tclip/playground": typeof AuthenticatedUserTclipPlaygroundLazyRoute;
  "/user/tclip/templates": typeof AuthenticatedUserTclipTemplatesLazyRoute;
  "/user/tclip/transcripts": typeof AuthenticatedUserTclipTranscriptsLazyRoute;
  "/onboarding/v2/": typeof AuthenticatedOnboardingV2IndexRoute;
  "/user/apps/": typeof AuthenticatedUserAppsIndexRoute;
  "/user/dsp/": typeof AuthenticatedUserDspIndexRoute;
  "/user/pricing/": typeof AuthenticatedUserPricingIndexRoute;
  "/user/productlaunch/": typeof AuthenticatedUserProductlaunchIndexRoute;
  "/user/programs/": typeof AuthenticatedUserProgramsIndexRoute;
  "/user/searchqueryperformance/": typeof AuthenticatedUserSearchqueryperformanceIndexRoute;
  "/onboarding/v2/about/sales": typeof AuthenticatedOnboardingV2AboutSalesRoute;
  "/onboarding/v2/about/type": typeof AuthenticatedOnboardingV2AboutTypeRoute;
  "/user/advertising/programs/create": typeof AuthenticatedUserAdvertisingProgramsCreateRoute;
  "/user/amc/conversionchart/reports": typeof AuthenticatedUserAmcConversionchartReportsRoute;
  "/user/content/quality/org": typeof AuthenticatedUserContentQualityOrgRoute;
  "/user/content/templates/$templateId": typeof AuthenticatedUserContentTemplatesTemplateIdRoute;
  "/user/dsp/$dspAdvertiser/dashboard": typeof AuthenticatedUserDspDspAdvertiserDashboardRoute;
  "/user/merchandising/category/$category": typeof AuthenticatedUserMerchandisingCategoryCategoryRoute;
  "/user/merchandising/coupons/$coupon": typeof AuthenticatedUserMerchandisingCouponsCouponRoute;
  "/user/merchandising/parent/$parentAsin": typeof AuthenticatedUserMerchandisingParentParentAsinRoute;
  "/user/merchandising/product/$product": typeof AuthenticatedUserMerchandisingProductProductRoute;
  "/user/pricing/plan/$plan": typeof AuthenticatedUserPricingPlanPlanRoute;
  "/user/productlaunch/launches/$id": typeof AuthenticatedUserProductlaunchLaunchesIdRoute;
  "/user/programs/edit/$id": typeof AuthenticatedUserProgramsEditIdRoute;
  "/user/report/organization/summary": typeof AuthenticatedUserReportOrganizationSummaryRoute;
  "/user/staff/reportcard/$org_id": typeof AuthenticatedUserStaffReportcardOrg_idRoute;
  "/user/staff/user-activity/$org_id": typeof AuthenticatedUserStaffUserActivityOrg_idRoute;
  "/user/staff/walmart/profiles": typeof AuthenticatedUserStaffWalmartProfilesRoute;
  "/user/staff/workflows/$workflow_id": typeof AuthenticatedUserStaffWorkflowsWorkflow_idRoute;
  "/user/tclip/agent/$agentId": typeof AuthenticatedUserTclipAgentAgentIdLazyRoute;
  "/user/advertising/dashboard/": typeof AuthenticatedUserAdvertisingDashboardIndexRoute;
  "/user/advertising/programs/": typeof AuthenticatedUserAdvertisingProgramsIndexRoute;
  "/user/amc/dashboard/": typeof AuthenticatedUserAmcDashboardIndexRoute;
  "/user/merchandising/coupons/": typeof AuthenticatedUserMerchandisingCouponsIndexRoute;
  "/user/pl/report/": typeof AuthenticatedUserPlReportIndexRoute;
  "/user/pricing/dashboard/": typeof AuthenticatedUserPricingDashboardIndexRoute;
  "/user/pricing/management/": typeof AuthenticatedUserPricingManagementIndexRoute;
  "/user/staff/reportcard/": typeof AuthenticatedUserStaffReportcardIndexRoute;
  "/user/staff/user-activity/": typeof AuthenticatedUserStaffUserActivityIndexRoute;
  "/user/staff/workflows/": typeof AuthenticatedUserStaffWorkflowsIndexRoute;
  "/user/advertising/dashboard/ads/$id": typeof AuthenticatedUserAdvertisingDashboardAdsIdRoute;
  "/user/advertising/dashboard/category/$id": typeof AuthenticatedUserAdvertisingDashboardCategoryIdRoute;
  "/user/advertising/programs/edit/$id": typeof AuthenticatedUserAdvertisingProgramsEditIdRoute;
  "/user/amc/dashboard/reports/$id": typeof AuthenticatedUserAmcDashboardReportsIdRoute;
  "/user/content/quality/category/$category": typeof AuthenticatedUserContentQualityCategoryCategoryRoute;
  "/user/dsp/$dspAdvertiser/lineitems/$id": typeof AuthenticatedUserDspDspAdvertiserLineitemsIdRoute;
  "/user/dsp/$dspAdvertiser/orders/$id": typeof AuthenticatedUserDspDspAdvertiserOrdersIdRoute;
  "/user/pricing/dashboard/category/$category": typeof AuthenticatedUserPricingDashboardCategoryCategoryRoute;
  "/user/pricing/management/category/$category": typeof AuthenticatedUserPricingManagementCategoryCategoryRoute;
  "/user/amc/dashboard/reports/details/$id": typeof AuthenticatedUserAmcDashboardReportsDetailsIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/pdf": typeof PdfRouteRouteWithChildren;
  "/signup": typeof SignupRoute;
  "/connect/tiktok": typeof ConnectTiktokRoute;
  "/shopify/install": typeof ShopifyInstallRoute;
  "/signin/resetpassword": typeof SigninResetpasswordRoute;
  "/signin": typeof SigninIndexRoute;
  "/user/live": typeof AuthenticatedUserLiveRouteRouteWithChildren;
  "/user/merchandising": typeof AuthenticatedUserMerchandisingRouteRouteWithChildren;
  "/user/pl": typeof AuthenticatedUserPlRouteRouteWithChildren;
  "/user/tclip": typeof AuthenticatedUserTclipRouteRouteWithChildren;
  "/mcp/authorize": typeof AuthenticatedMcpAuthorizeRoute;
  "/user/amzsummary": typeof AuthenticatedUserAmzsummaryRoute;
  "/user/applications": typeof AuthenticatedUserApplicationsRoute;
  "/user/billing": typeof AuthenticatedUserBillingRoute;
  "/user/categorymanagement": typeof AuthenticatedUserCategorymanagementRoute;
  "/user/chromeaccess": typeof AuthenticatedUserChromeaccessRoute;
  "/user/dashboard": typeof AuthenticatedUserDashboardRoute;
  "/user/data-status": typeof AuthenticatedUserDataStatusRoute;
  "/user/goals": typeof AuthenticatedUserGoalsRoute;
  "/user/mcp": typeof AuthenticatedUserMcpRoute;
  "/user/payment": typeof AuthenticatedUserPaymentRoute;
  "/user/plans": typeof AuthenticatedUserPlansRoute;
  "/user/searchanalytics": typeof AuthenticatedUserSearchanalyticsRoute;
  "/user/settings": typeof AuthenticatedUserSettingsRoute;
  "/user/shopifysummary": typeof AuthenticatedUserShopifysummaryRoute;
  "/user/shopperinsightsV2": typeof AuthenticatedUserShopperinsightsV2Route;
  "/user/tagmanagement": typeof AuthenticatedUserTagmanagementRoute;
  "/user/tickets": typeof AuthenticatedUserTicketsRoute;
  "/user/trmnl": typeof AuthenticatedUserTrmnlRoute;
  "/user/uploads": typeof AuthenticatedUserUploadsRoute;
  "/user/usermanagement": typeof AuthenticatedUserUsermanagementRoute;
  "/user/verify": typeof AuthenticatedUserVerifyRoute;
  "/user/videogen": typeof AuthenticatedUserVideogenRoute;
  "/user/walmartsummary": typeof AuthenticatedUserWalmartsummaryRoute;
  "/walmart/install": typeof AuthenticatedWalmartInstallRoute;
  "/oauth/amazon/advertising": typeof OauthAmazonAdvertisingRoute;
  "/oauth/amazon/spapi": typeof OauthAmazonSpapiRoute;
  "/user": typeof AuthenticatedUserIndexRoute;
  "/onboarding/v2/channel": typeof AuthenticatedOnboardingV2ChannelRoute;
  "/onboarding/v2/connect": typeof AuthenticatedOnboardingV2ConnectRoute;
  "/onboarding/v2/profiles": typeof AuthenticatedOnboardingV2ProfilesRoute;
  "/onboarding/v2/sellertype": typeof AuthenticatedOnboardingV2SellertypeRoute;
  "/onboarding/v2/summary": typeof AuthenticatedOnboardingV2SummaryRoute;
  "/user/advertising/settings": typeof AuthenticatedUserAdvertisingSettingsRoute;
  "/user/agency/dashboard": typeof AuthenticatedUserAgencyDashboardRoute;
  "/user/amc/configuration": typeof AuthenticatedUserAmcConfigurationRoute;
  "/user/amc/shopperinsightsV2": typeof AuthenticatedUserAmcShopperinsightsV2Route;
  "/user/apps/shopify": typeof AuthenticatedUserAppsShopifyRoute;
  "/user/audience/dashboard": typeof AuthenticatedUserAudienceDashboardRoute;
  "/user/content/seo": typeof AuthenticatedUserContentSeoRoute;
  "/user/live/report": typeof AuthenticatedUserLiveReportRoute;
  "/user/merchandising/dashboard": typeof AuthenticatedUserMerchandisingDashboardRoute;
  "/user/merchandising/promotions": typeof AuthenticatedUserMerchandisingPromotionsRoute;
  "/user/pricing/buybox": typeof AuthenticatedUserPricingBuyboxRoute;
  "/user/pricing/changes": typeof AuthenticatedUserPricingChangesRoute;
  "/user/pricing/configuration": typeof AuthenticatedUserPricingConfigurationRoute;
  "/user/pricing/forecast": typeof AuthenticatedUserPricingForecastRoute;
  "/user/productlaunch/new": typeof AuthenticatedUserProductlaunchNewRoute;
  "/user/programs/create": typeof AuthenticatedUserProgramsCreateRoute;
  "/user/report/advertisement": typeof AuthenticatedUserReportAdvertisementRoute;
  "/user/report/audience": typeof AuthenticatedUserReportAudienceRoute;
  "/user/report/export": typeof AuthenticatedUserReportExportRoute;
  "/user/report/pricing_plan": typeof AuthenticatedUserReportPricing_planRoute;
  "/user/report/product": typeof AuthenticatedUserReportProductRoute;
  "/user/report/product_ad": typeof AuthenticatedUserReportProduct_adRoute;
  "/user/report/sqpr_report": typeof AuthenticatedUserReportSqpr_reportRoute;
  "/user/report/str_report": typeof AuthenticatedUserReportStr_reportRoute;
  "/user/report/target": typeof AuthenticatedUserReportTargetRoute;
  "/user/searchqueryperformance/$id": typeof AuthenticatedUserSearchqueryperformanceIdRoute;
  "/user/staff/dashboard": typeof AuthenticatedUserStaffDashboardRoute;
  "/user/tclip/agents": typeof AuthenticatedUserTclipAgentsRoute;
  "/user/tclip/tasks": typeof AuthenticatedUserTclipTasksRoute;
  "/user/userdetails/$id": typeof AuthenticatedUserUserdetailsIdRoute;
  "/pdf/report/organization/summary": typeof PdfReportOrganizationSummaryRoute;
  "/user/tclip/playground": typeof AuthenticatedUserTclipPlaygroundLazyRoute;
  "/user/tclip/templates": typeof AuthenticatedUserTclipTemplatesLazyRoute;
  "/user/tclip/transcripts": typeof AuthenticatedUserTclipTranscriptsLazyRoute;
  "/onboarding/v2": typeof AuthenticatedOnboardingV2IndexRoute;
  "/user/apps": typeof AuthenticatedUserAppsIndexRoute;
  "/user/dsp": typeof AuthenticatedUserDspIndexRoute;
  "/user/pricing": typeof AuthenticatedUserPricingIndexRoute;
  "/user/productlaunch": typeof AuthenticatedUserProductlaunchIndexRoute;
  "/user/programs": typeof AuthenticatedUserProgramsIndexRoute;
  "/user/searchqueryperformance": typeof AuthenticatedUserSearchqueryperformanceIndexRoute;
  "/onboarding/v2/about/sales": typeof AuthenticatedOnboardingV2AboutSalesRoute;
  "/onboarding/v2/about/type": typeof AuthenticatedOnboardingV2AboutTypeRoute;
  "/user/advertising/programs/create": typeof AuthenticatedUserAdvertisingProgramsCreateRoute;
  "/user/amc/conversionchart/reports": typeof AuthenticatedUserAmcConversionchartReportsRoute;
  "/user/content/quality/org": typeof AuthenticatedUserContentQualityOrgRoute;
  "/user/content/templates/$templateId": typeof AuthenticatedUserContentTemplatesTemplateIdRoute;
  "/user/dsp/$dspAdvertiser/dashboard": typeof AuthenticatedUserDspDspAdvertiserDashboardRoute;
  "/user/merchandising/category/$category": typeof AuthenticatedUserMerchandisingCategoryCategoryRoute;
  "/user/merchandising/coupons/$coupon": typeof AuthenticatedUserMerchandisingCouponsCouponRoute;
  "/user/merchandising/parent/$parentAsin": typeof AuthenticatedUserMerchandisingParentParentAsinRoute;
  "/user/merchandising/product/$product": typeof AuthenticatedUserMerchandisingProductProductRoute;
  "/user/pricing/plan/$plan": typeof AuthenticatedUserPricingPlanPlanRoute;
  "/user/productlaunch/launches/$id": typeof AuthenticatedUserProductlaunchLaunchesIdRoute;
  "/user/programs/edit/$id": typeof AuthenticatedUserProgramsEditIdRoute;
  "/user/report/organization/summary": typeof AuthenticatedUserReportOrganizationSummaryRoute;
  "/user/staff/reportcard/$org_id": typeof AuthenticatedUserStaffReportcardOrg_idRoute;
  "/user/staff/user-activity/$org_id": typeof AuthenticatedUserStaffUserActivityOrg_idRoute;
  "/user/staff/walmart/profiles": typeof AuthenticatedUserStaffWalmartProfilesRoute;
  "/user/staff/workflows/$workflow_id": typeof AuthenticatedUserStaffWorkflowsWorkflow_idRoute;
  "/user/tclip/agent/$agentId": typeof AuthenticatedUserTclipAgentAgentIdLazyRoute;
  "/user/advertising/dashboard": typeof AuthenticatedUserAdvertisingDashboardIndexRoute;
  "/user/advertising/programs": typeof AuthenticatedUserAdvertisingProgramsIndexRoute;
  "/user/amc/dashboard": typeof AuthenticatedUserAmcDashboardIndexRoute;
  "/user/merchandising/coupons": typeof AuthenticatedUserMerchandisingCouponsIndexRoute;
  "/user/pl/report": typeof AuthenticatedUserPlReportIndexRoute;
  "/user/pricing/dashboard": typeof AuthenticatedUserPricingDashboardIndexRoute;
  "/user/pricing/management": typeof AuthenticatedUserPricingManagementIndexRoute;
  "/user/staff/reportcard": typeof AuthenticatedUserStaffReportcardIndexRoute;
  "/user/staff/user-activity": typeof AuthenticatedUserStaffUserActivityIndexRoute;
  "/user/staff/workflows": typeof AuthenticatedUserStaffWorkflowsIndexRoute;
  "/user/advertising/dashboard/ads/$id": typeof AuthenticatedUserAdvertisingDashboardAdsIdRoute;
  "/user/advertising/dashboard/category/$id": typeof AuthenticatedUserAdvertisingDashboardCategoryIdRoute;
  "/user/advertising/programs/edit/$id": typeof AuthenticatedUserAdvertisingProgramsEditIdRoute;
  "/user/amc/dashboard/reports/$id": typeof AuthenticatedUserAmcDashboardReportsIdRoute;
  "/user/content/quality/category/$category": typeof AuthenticatedUserContentQualityCategoryCategoryRoute;
  "/user/dsp/$dspAdvertiser/lineitems/$id": typeof AuthenticatedUserDspDspAdvertiserLineitemsIdRoute;
  "/user/dsp/$dspAdvertiser/orders/$id": typeof AuthenticatedUserDspDspAdvertiserOrdersIdRoute;
  "/user/pricing/dashboard/category/$category": typeof AuthenticatedUserPricingDashboardCategoryCategoryRoute;
  "/user/pricing/management/category/$category": typeof AuthenticatedUserPricingManagementCategoryCategoryRoute;
  "/user/amc/dashboard/reports/details/$id": typeof AuthenticatedUserAmcDashboardReportsDetailsIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren;
  "/pdf": typeof PdfRouteRouteWithChildren;
  "/signup": typeof SignupRoute;
  "/_authenticated/user": typeof AuthenticatedUserRouteRouteWithChildren;
  "/connect/tiktok": typeof ConnectTiktokRoute;
  "/shopify/install": typeof ShopifyInstallRoute;
  "/signin/resetpassword": typeof SigninResetpasswordRoute;
  "/signin/": typeof SigninIndexRoute;
  "/_authenticated/onboarding/v2": typeof AuthenticatedOnboardingV2RouteRouteWithChildren;
  "/_authenticated/user/live": typeof AuthenticatedUserLiveRouteRouteWithChildren;
  "/_authenticated/user/merchandising": typeof AuthenticatedUserMerchandisingRouteRouteWithChildren;
  "/_authenticated/user/pl": typeof AuthenticatedUserPlRouteRouteWithChildren;
  "/_authenticated/user/pricing": typeof AuthenticatedUserPricingRouteRouteWithChildren;
  "/_authenticated/user/productlaunch": typeof AuthenticatedUserProductlaunchRouteRouteWithChildren;
  "/_authenticated/user/programs": typeof AuthenticatedUserProgramsRouteRouteWithChildren;
  "/_authenticated/user/searchqueryperformance": typeof AuthenticatedUserSearchqueryperformanceRouteRouteWithChildren;
  "/_authenticated/user/tclip": typeof AuthenticatedUserTclipRouteRouteWithChildren;
  "/_authenticated/mcp/authorize": typeof AuthenticatedMcpAuthorizeRoute;
  "/_authenticated/user/amzsummary": typeof AuthenticatedUserAmzsummaryRoute;
  "/_authenticated/user/applications": typeof AuthenticatedUserApplicationsRoute;
  "/_authenticated/user/billing": typeof AuthenticatedUserBillingRoute;
  "/_authenticated/user/categorymanagement": typeof AuthenticatedUserCategorymanagementRoute;
  "/_authenticated/user/chromeaccess": typeof AuthenticatedUserChromeaccessRoute;
  "/_authenticated/user/dashboard": typeof AuthenticatedUserDashboardRoute;
  "/_authenticated/user/data-status": typeof AuthenticatedUserDataStatusRoute;
  "/_authenticated/user/goals": typeof AuthenticatedUserGoalsRoute;
  "/_authenticated/user/mcp": typeof AuthenticatedUserMcpRoute;
  "/_authenticated/user/payment": typeof AuthenticatedUserPaymentRoute;
  "/_authenticated/user/plans": typeof AuthenticatedUserPlansRoute;
  "/_authenticated/user/searchanalytics": typeof AuthenticatedUserSearchanalyticsRoute;
  "/_authenticated/user/settings": typeof AuthenticatedUserSettingsRoute;
  "/_authenticated/user/shopifysummary": typeof AuthenticatedUserShopifysummaryRoute;
  "/_authenticated/user/shopperinsightsV2": typeof AuthenticatedUserShopperinsightsV2Route;
  "/_authenticated/user/tagmanagement": typeof AuthenticatedUserTagmanagementRoute;
  "/_authenticated/user/tickets": typeof AuthenticatedUserTicketsRoute;
  "/_authenticated/user/trmnl": typeof AuthenticatedUserTrmnlRoute;
  "/_authenticated/user/uploads": typeof AuthenticatedUserUploadsRoute;
  "/_authenticated/user/usermanagement": typeof AuthenticatedUserUsermanagementRoute;
  "/_authenticated/user/verify": typeof AuthenticatedUserVerifyRoute;
  "/_authenticated/user/videogen": typeof AuthenticatedUserVideogenRoute;
  "/_authenticated/user/walmartsummary": typeof AuthenticatedUserWalmartsummaryRoute;
  "/_authenticated/walmart/install": typeof AuthenticatedWalmartInstallRoute;
  "/oauth/amazon/advertising": typeof OauthAmazonAdvertisingRoute;
  "/oauth/amazon/spapi": typeof OauthAmazonSpapiRoute;
  "/_authenticated/user/": typeof AuthenticatedUserIndexRoute;
  "/_authenticated/user/advertising/programs": typeof AuthenticatedUserAdvertisingProgramsRouteRouteWithChildren;
  "/_authenticated/user/staff/reportcard": typeof AuthenticatedUserStaffReportcardRouteRouteWithChildren;
  "/_authenticated/user/staff/user-activity": typeof AuthenticatedUserStaffUserActivityRouteRouteWithChildren;
  "/_authenticated/user/staff/workflows": typeof AuthenticatedUserStaffWorkflowsRouteRouteWithChildren;
  "/_authenticated/onboarding/v2/channel": typeof AuthenticatedOnboardingV2ChannelRoute;
  "/_authenticated/onboarding/v2/connect": typeof AuthenticatedOnboardingV2ConnectRoute;
  "/_authenticated/onboarding/v2/profiles": typeof AuthenticatedOnboardingV2ProfilesRoute;
  "/_authenticated/onboarding/v2/sellertype": typeof AuthenticatedOnboardingV2SellertypeRoute;
  "/_authenticated/onboarding/v2/summary": typeof AuthenticatedOnboardingV2SummaryRoute;
  "/_authenticated/user/advertising/settings": typeof AuthenticatedUserAdvertisingSettingsRoute;
  "/_authenticated/user/agency/dashboard": typeof AuthenticatedUserAgencyDashboardRoute;
  "/_authenticated/user/amc/configuration": typeof AuthenticatedUserAmcConfigurationRoute;
  "/_authenticated/user/amc/shopperinsightsV2": typeof AuthenticatedUserAmcShopperinsightsV2Route;
  "/_authenticated/user/apps/shopify": typeof AuthenticatedUserAppsShopifyRoute;
  "/_authenticated/user/audience/dashboard": typeof AuthenticatedUserAudienceDashboardRoute;
  "/_authenticated/user/content/seo": typeof AuthenticatedUserContentSeoRoute;
  "/_authenticated/user/live/report": typeof AuthenticatedUserLiveReportRoute;
  "/_authenticated/user/merchandising/dashboard": typeof AuthenticatedUserMerchandisingDashboardRoute;
  "/_authenticated/user/merchandising/promotions": typeof AuthenticatedUserMerchandisingPromotionsRoute;
  "/_authenticated/user/pricing/buybox": typeof AuthenticatedUserPricingBuyboxRoute;
  "/_authenticated/user/pricing/changes": typeof AuthenticatedUserPricingChangesRoute;
  "/_authenticated/user/pricing/configuration": typeof AuthenticatedUserPricingConfigurationRoute;
  "/_authenticated/user/pricing/forecast": typeof AuthenticatedUserPricingForecastRoute;
  "/_authenticated/user/productlaunch/new": typeof AuthenticatedUserProductlaunchNewRoute;
  "/_authenticated/user/programs/create": typeof AuthenticatedUserProgramsCreateRoute;
  "/_authenticated/user/report/advertisement": typeof AuthenticatedUserReportAdvertisementRoute;
  "/_authenticated/user/report/audience": typeof AuthenticatedUserReportAudienceRoute;
  "/_authenticated/user/report/export": typeof AuthenticatedUserReportExportRoute;
  "/_authenticated/user/report/pricing_plan": typeof AuthenticatedUserReportPricing_planRoute;
  "/_authenticated/user/report/product": typeof AuthenticatedUserReportProductRoute;
  "/_authenticated/user/report/product_ad": typeof AuthenticatedUserReportProduct_adRoute;
  "/_authenticated/user/report/sqpr_report": typeof AuthenticatedUserReportSqpr_reportRoute;
  "/_authenticated/user/report/str_report": typeof AuthenticatedUserReportStr_reportRoute;
  "/_authenticated/user/report/target": typeof AuthenticatedUserReportTargetRoute;
  "/_authenticated/user/searchqueryperformance/$id": typeof AuthenticatedUserSearchqueryperformanceIdRoute;
  "/_authenticated/user/staff/dashboard": typeof AuthenticatedUserStaffDashboardRoute;
  "/_authenticated/user/tclip/agents": typeof AuthenticatedUserTclipAgentsRoute;
  "/_authenticated/user/tclip/tasks": typeof AuthenticatedUserTclipTasksRoute;
  "/_authenticated/user/userdetails/$id": typeof AuthenticatedUserUserdetailsIdRoute;
  "/pdf/report/organization/summary": typeof PdfReportOrganizationSummaryRoute;
  "/_authenticated/user/tclip/playground": typeof AuthenticatedUserTclipPlaygroundLazyRoute;
  "/_authenticated/user/tclip/templates": typeof AuthenticatedUserTclipTemplatesLazyRoute;
  "/_authenticated/user/tclip/transcripts": typeof AuthenticatedUserTclipTranscriptsLazyRoute;
  "/_authenticated/onboarding/v2/": typeof AuthenticatedOnboardingV2IndexRoute;
  "/_authenticated/user/apps/": typeof AuthenticatedUserAppsIndexRoute;
  "/_authenticated/user/dsp/": typeof AuthenticatedUserDspIndexRoute;
  "/_authenticated/user/pricing/": typeof AuthenticatedUserPricingIndexRoute;
  "/_authenticated/user/productlaunch/": typeof AuthenticatedUserProductlaunchIndexRoute;
  "/_authenticated/user/programs/": typeof AuthenticatedUserProgramsIndexRoute;
  "/_authenticated/user/searchqueryperformance/": typeof AuthenticatedUserSearchqueryperformanceIndexRoute;
  "/_authenticated/onboarding/v2/about/sales": typeof AuthenticatedOnboardingV2AboutSalesRoute;
  "/_authenticated/onboarding/v2/about/type": typeof AuthenticatedOnboardingV2AboutTypeRoute;
  "/_authenticated/user/advertising/programs/create": typeof AuthenticatedUserAdvertisingProgramsCreateRoute;
  "/_authenticated/user/amc/conversionchart/reports": typeof AuthenticatedUserAmcConversionchartReportsRoute;
  "/_authenticated/user/content/quality/org": typeof AuthenticatedUserContentQualityOrgRoute;
  "/_authenticated/user/content/templates/$templateId": typeof AuthenticatedUserContentTemplatesTemplateIdRoute;
  "/_authenticated/user/dsp/$dspAdvertiser/dashboard": typeof AuthenticatedUserDspDspAdvertiserDashboardRoute;
  "/_authenticated/user/merchandising/category/$category": typeof AuthenticatedUserMerchandisingCategoryCategoryRoute;
  "/_authenticated/user/merchandising/coupons/$coupon": typeof AuthenticatedUserMerchandisingCouponsCouponRoute;
  "/_authenticated/user/merchandising/parent/$parentAsin": typeof AuthenticatedUserMerchandisingParentParentAsinRoute;
  "/_authenticated/user/merchandising/product/$product": typeof AuthenticatedUserMerchandisingProductProductRoute;
  "/_authenticated/user/pricing/plan/$plan": typeof AuthenticatedUserPricingPlanPlanRoute;
  "/_authenticated/user/productlaunch/launches/$id": typeof AuthenticatedUserProductlaunchLaunchesIdRoute;
  "/_authenticated/user/programs/edit/$id": typeof AuthenticatedUserProgramsEditIdRoute;
  "/_authenticated/user/report/organization/summary": typeof AuthenticatedUserReportOrganizationSummaryRoute;
  "/_authenticated/user/staff/reportcard/$org_id": typeof AuthenticatedUserStaffReportcardOrg_idRoute;
  "/_authenticated/user/staff/user-activity/$org_id": typeof AuthenticatedUserStaffUserActivityOrg_idRoute;
  "/_authenticated/user/staff/walmart/profiles": typeof AuthenticatedUserStaffWalmartProfilesRoute;
  "/_authenticated/user/staff/workflows/$workflow_id": typeof AuthenticatedUserStaffWorkflowsWorkflow_idRoute;
  "/_authenticated/user/tclip/agent/$agentId": typeof AuthenticatedUserTclipAgentAgentIdLazyRoute;
  "/_authenticated/user/advertising/dashboard/": typeof AuthenticatedUserAdvertisingDashboardIndexRoute;
  "/_authenticated/user/advertising/programs/": typeof AuthenticatedUserAdvertisingProgramsIndexRoute;
  "/_authenticated/user/amc/dashboard/": typeof AuthenticatedUserAmcDashboardIndexRoute;
  "/_authenticated/user/merchandising/coupons/": typeof AuthenticatedUserMerchandisingCouponsIndexRoute;
  "/_authenticated/user/pl/report/": typeof AuthenticatedUserPlReportIndexRoute;
  "/_authenticated/user/pricing/dashboard/": typeof AuthenticatedUserPricingDashboardIndexRoute;
  "/_authenticated/user/pricing/management/": typeof AuthenticatedUserPricingManagementIndexRoute;
  "/_authenticated/user/staff/reportcard/": typeof AuthenticatedUserStaffReportcardIndexRoute;
  "/_authenticated/user/staff/user-activity/": typeof AuthenticatedUserStaffUserActivityIndexRoute;
  "/_authenticated/user/staff/workflows/": typeof AuthenticatedUserStaffWorkflowsIndexRoute;
  "/_authenticated/user/advertising/dashboard/ads/$id": typeof AuthenticatedUserAdvertisingDashboardAdsIdRoute;
  "/_authenticated/user/advertising/dashboard/category/$id": typeof AuthenticatedUserAdvertisingDashboardCategoryIdRoute;
  "/_authenticated/user/advertising/programs/edit/$id": typeof AuthenticatedUserAdvertisingProgramsEditIdRoute;
  "/_authenticated/user/amc/dashboard/reports/$id": typeof AuthenticatedUserAmcDashboardReportsIdRoute;
  "/_authenticated/user/content/quality/category/$category": typeof AuthenticatedUserContentQualityCategoryCategoryRoute;
  "/_authenticated/user/dsp/$dspAdvertiser/lineitems/$id": typeof AuthenticatedUserDspDspAdvertiserLineitemsIdRoute;
  "/_authenticated/user/dsp/$dspAdvertiser/orders/$id": typeof AuthenticatedUserDspDspAdvertiserOrdersIdRoute;
  "/_authenticated/user/pricing/dashboard/category/$category": typeof AuthenticatedUserPricingDashboardCategoryCategoryRoute;
  "/_authenticated/user/pricing/management/category/$category": typeof AuthenticatedUserPricingManagementCategoryCategoryRoute;
  "/_authenticated/user/amc/dashboard/reports/details/$id": typeof AuthenticatedUserAmcDashboardReportsDetailsIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/pdf"
    | "/signup"
    | "/user"
    | "/connect/tiktok"
    | "/shopify/install"
    | "/signin/resetpassword"
    | "/signin/"
    | "/onboarding/v2"
    | "/user/live"
    | "/user/merchandising"
    | "/user/pl"
    | "/user/pricing"
    | "/user/productlaunch"
    | "/user/programs"
    | "/user/searchqueryperformance"
    | "/user/tclip"
    | "/mcp/authorize"
    | "/user/amzsummary"
    | "/user/applications"
    | "/user/billing"
    | "/user/categorymanagement"
    | "/user/chromeaccess"
    | "/user/dashboard"
    | "/user/data-status"
    | "/user/goals"
    | "/user/mcp"
    | "/user/payment"
    | "/user/plans"
    | "/user/searchanalytics"
    | "/user/settings"
    | "/user/shopifysummary"
    | "/user/shopperinsightsV2"
    | "/user/tagmanagement"
    | "/user/tickets"
    | "/user/trmnl"
    | "/user/uploads"
    | "/user/usermanagement"
    | "/user/verify"
    | "/user/videogen"
    | "/user/walmartsummary"
    | "/walmart/install"
    | "/oauth/amazon/advertising"
    | "/oauth/amazon/spapi"
    | "/user/"
    | "/user/advertising/programs"
    | "/user/staff/reportcard"
    | "/user/staff/user-activity"
    | "/user/staff/workflows"
    | "/onboarding/v2/channel"
    | "/onboarding/v2/connect"
    | "/onboarding/v2/profiles"
    | "/onboarding/v2/sellertype"
    | "/onboarding/v2/summary"
    | "/user/advertising/settings"
    | "/user/agency/dashboard"
    | "/user/amc/configuration"
    | "/user/amc/shopperinsightsV2"
    | "/user/apps/shopify"
    | "/user/audience/dashboard"
    | "/user/content/seo"
    | "/user/live/report"
    | "/user/merchandising/dashboard"
    | "/user/merchandising/promotions"
    | "/user/pricing/buybox"
    | "/user/pricing/changes"
    | "/user/pricing/configuration"
    | "/user/pricing/forecast"
    | "/user/productlaunch/new"
    | "/user/programs/create"
    | "/user/report/advertisement"
    | "/user/report/audience"
    | "/user/report/export"
    | "/user/report/pricing_plan"
    | "/user/report/product"
    | "/user/report/product_ad"
    | "/user/report/sqpr_report"
    | "/user/report/str_report"
    | "/user/report/target"
    | "/user/searchqueryperformance/$id"
    | "/user/staff/dashboard"
    | "/user/tclip/agents"
    | "/user/tclip/tasks"
    | "/user/userdetails/$id"
    | "/pdf/report/organization/summary"
    | "/user/tclip/playground"
    | "/user/tclip/templates"
    | "/user/tclip/transcripts"
    | "/onboarding/v2/"
    | "/user/apps/"
    | "/user/dsp/"
    | "/user/pricing/"
    | "/user/productlaunch/"
    | "/user/programs/"
    | "/user/searchqueryperformance/"
    | "/onboarding/v2/about/sales"
    | "/onboarding/v2/about/type"
    | "/user/advertising/programs/create"
    | "/user/amc/conversionchart/reports"
    | "/user/content/quality/org"
    | "/user/content/templates/$templateId"
    | "/user/dsp/$dspAdvertiser/dashboard"
    | "/user/merchandising/category/$category"
    | "/user/merchandising/coupons/$coupon"
    | "/user/merchandising/parent/$parentAsin"
    | "/user/merchandising/product/$product"
    | "/user/pricing/plan/$plan"
    | "/user/productlaunch/launches/$id"
    | "/user/programs/edit/$id"
    | "/user/report/organization/summary"
    | "/user/staff/reportcard/$org_id"
    | "/user/staff/user-activity/$org_id"
    | "/user/staff/walmart/profiles"
    | "/user/staff/workflows/$workflow_id"
    | "/user/tclip/agent/$agentId"
    | "/user/advertising/dashboard/"
    | "/user/advertising/programs/"
    | "/user/amc/dashboard/"
    | "/user/merchandising/coupons/"
    | "/user/pl/report/"
    | "/user/pricing/dashboard/"
    | "/user/pricing/management/"
    | "/user/staff/reportcard/"
    | "/user/staff/user-activity/"
    | "/user/staff/workflows/"
    | "/user/advertising/dashboard/ads/$id"
    | "/user/advertising/dashboard/category/$id"
    | "/user/advertising/programs/edit/$id"
    | "/user/amc/dashboard/reports/$id"
    | "/user/content/quality/category/$category"
    | "/user/dsp/$dspAdvertiser/lineitems/$id"
    | "/user/dsp/$dspAdvertiser/orders/$id"
    | "/user/pricing/dashboard/category/$category"
    | "/user/pricing/management/category/$category"
    | "/user/amc/dashboard/reports/details/$id";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/pdf"
    | "/signup"
    | "/connect/tiktok"
    | "/shopify/install"
    | "/signin/resetpassword"
    | "/signin"
    | "/user/live"
    | "/user/merchandising"
    | "/user/pl"
    | "/user/tclip"
    | "/mcp/authorize"
    | "/user/amzsummary"
    | "/user/applications"
    | "/user/billing"
    | "/user/categorymanagement"
    | "/user/chromeaccess"
    | "/user/dashboard"
    | "/user/data-status"
    | "/user/goals"
    | "/user/mcp"
    | "/user/payment"
    | "/user/plans"
    | "/user/searchanalytics"
    | "/user/settings"
    | "/user/shopifysummary"
    | "/user/shopperinsightsV2"
    | "/user/tagmanagement"
    | "/user/tickets"
    | "/user/trmnl"
    | "/user/uploads"
    | "/user/usermanagement"
    | "/user/verify"
    | "/user/videogen"
    | "/user/walmartsummary"
    | "/walmart/install"
    | "/oauth/amazon/advertising"
    | "/oauth/amazon/spapi"
    | "/user"
    | "/onboarding/v2/channel"
    | "/onboarding/v2/connect"
    | "/onboarding/v2/profiles"
    | "/onboarding/v2/sellertype"
    | "/onboarding/v2/summary"
    | "/user/advertising/settings"
    | "/user/agency/dashboard"
    | "/user/amc/configuration"
    | "/user/amc/shopperinsightsV2"
    | "/user/apps/shopify"
    | "/user/audience/dashboard"
    | "/user/content/seo"
    | "/user/live/report"
    | "/user/merchandising/dashboard"
    | "/user/merchandising/promotions"
    | "/user/pricing/buybox"
    | "/user/pricing/changes"
    | "/user/pricing/configuration"
    | "/user/pricing/forecast"
    | "/user/productlaunch/new"
    | "/user/programs/create"
    | "/user/report/advertisement"
    | "/user/report/audience"
    | "/user/report/export"
    | "/user/report/pricing_plan"
    | "/user/report/product"
    | "/user/report/product_ad"
    | "/user/report/sqpr_report"
    | "/user/report/str_report"
    | "/user/report/target"
    | "/user/searchqueryperformance/$id"
    | "/user/staff/dashboard"
    | "/user/tclip/agents"
    | "/user/tclip/tasks"
    | "/user/userdetails/$id"
    | "/pdf/report/organization/summary"
    | "/user/tclip/playground"
    | "/user/tclip/templates"
    | "/user/tclip/transcripts"
    | "/onboarding/v2"
    | "/user/apps"
    | "/user/dsp"
    | "/user/pricing"
    | "/user/productlaunch"
    | "/user/programs"
    | "/user/searchqueryperformance"
    | "/onboarding/v2/about/sales"
    | "/onboarding/v2/about/type"
    | "/user/advertising/programs/create"
    | "/user/amc/conversionchart/reports"
    | "/user/content/quality/org"
    | "/user/content/templates/$templateId"
    | "/user/dsp/$dspAdvertiser/dashboard"
    | "/user/merchandising/category/$category"
    | "/user/merchandising/coupons/$coupon"
    | "/user/merchandising/parent/$parentAsin"
    | "/user/merchandising/product/$product"
    | "/user/pricing/plan/$plan"
    | "/user/productlaunch/launches/$id"
    | "/user/programs/edit/$id"
    | "/user/report/organization/summary"
    | "/user/staff/reportcard/$org_id"
    | "/user/staff/user-activity/$org_id"
    | "/user/staff/walmart/profiles"
    | "/user/staff/workflows/$workflow_id"
    | "/user/tclip/agent/$agentId"
    | "/user/advertising/dashboard"
    | "/user/advertising/programs"
    | "/user/amc/dashboard"
    | "/user/merchandising/coupons"
    | "/user/pl/report"
    | "/user/pricing/dashboard"
    | "/user/pricing/management"
    | "/user/staff/reportcard"
    | "/user/staff/user-activity"
    | "/user/staff/workflows"
    | "/user/advertising/dashboard/ads/$id"
    | "/user/advertising/dashboard/category/$id"
    | "/user/advertising/programs/edit/$id"
    | "/user/amc/dashboard/reports/$id"
    | "/user/content/quality/category/$category"
    | "/user/dsp/$dspAdvertiser/lineitems/$id"
    | "/user/dsp/$dspAdvertiser/orders/$id"
    | "/user/pricing/dashboard/category/$category"
    | "/user/pricing/management/category/$category"
    | "/user/amc/dashboard/reports/details/$id";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/pdf"
    | "/signup"
    | "/_authenticated/user"
    | "/connect/tiktok"
    | "/shopify/install"
    | "/signin/resetpassword"
    | "/signin/"
    | "/_authenticated/onboarding/v2"
    | "/_authenticated/user/live"
    | "/_authenticated/user/merchandising"
    | "/_authenticated/user/pl"
    | "/_authenticated/user/pricing"
    | "/_authenticated/user/productlaunch"
    | "/_authenticated/user/programs"
    | "/_authenticated/user/searchqueryperformance"
    | "/_authenticated/user/tclip"
    | "/_authenticated/mcp/authorize"
    | "/_authenticated/user/amzsummary"
    | "/_authenticated/user/applications"
    | "/_authenticated/user/billing"
    | "/_authenticated/user/categorymanagement"
    | "/_authenticated/user/chromeaccess"
    | "/_authenticated/user/dashboard"
    | "/_authenticated/user/data-status"
    | "/_authenticated/user/goals"
    | "/_authenticated/user/mcp"
    | "/_authenticated/user/payment"
    | "/_authenticated/user/plans"
    | "/_authenticated/user/searchanalytics"
    | "/_authenticated/user/settings"
    | "/_authenticated/user/shopifysummary"
    | "/_authenticated/user/shopperinsightsV2"
    | "/_authenticated/user/tagmanagement"
    | "/_authenticated/user/tickets"
    | "/_authenticated/user/trmnl"
    | "/_authenticated/user/uploads"
    | "/_authenticated/user/usermanagement"
    | "/_authenticated/user/verify"
    | "/_authenticated/user/videogen"
    | "/_authenticated/user/walmartsummary"
    | "/_authenticated/walmart/install"
    | "/oauth/amazon/advertising"
    | "/oauth/amazon/spapi"
    | "/_authenticated/user/"
    | "/_authenticated/user/advertising/programs"
    | "/_authenticated/user/staff/reportcard"
    | "/_authenticated/user/staff/user-activity"
    | "/_authenticated/user/staff/workflows"
    | "/_authenticated/onboarding/v2/channel"
    | "/_authenticated/onboarding/v2/connect"
    | "/_authenticated/onboarding/v2/profiles"
    | "/_authenticated/onboarding/v2/sellertype"
    | "/_authenticated/onboarding/v2/summary"
    | "/_authenticated/user/advertising/settings"
    | "/_authenticated/user/agency/dashboard"
    | "/_authenticated/user/amc/configuration"
    | "/_authenticated/user/amc/shopperinsightsV2"
    | "/_authenticated/user/apps/shopify"
    | "/_authenticated/user/audience/dashboard"
    | "/_authenticated/user/content/seo"
    | "/_authenticated/user/live/report"
    | "/_authenticated/user/merchandising/dashboard"
    | "/_authenticated/user/merchandising/promotions"
    | "/_authenticated/user/pricing/buybox"
    | "/_authenticated/user/pricing/changes"
    | "/_authenticated/user/pricing/configuration"
    | "/_authenticated/user/pricing/forecast"
    | "/_authenticated/user/productlaunch/new"
    | "/_authenticated/user/programs/create"
    | "/_authenticated/user/report/advertisement"
    | "/_authenticated/user/report/audience"
    | "/_authenticated/user/report/export"
    | "/_authenticated/user/report/pricing_plan"
    | "/_authenticated/user/report/product"
    | "/_authenticated/user/report/product_ad"
    | "/_authenticated/user/report/sqpr_report"
    | "/_authenticated/user/report/str_report"
    | "/_authenticated/user/report/target"
    | "/_authenticated/user/searchqueryperformance/$id"
    | "/_authenticated/user/staff/dashboard"
    | "/_authenticated/user/tclip/agents"
    | "/_authenticated/user/tclip/tasks"
    | "/_authenticated/user/userdetails/$id"
    | "/pdf/report/organization/summary"
    | "/_authenticated/user/tclip/playground"
    | "/_authenticated/user/tclip/templates"
    | "/_authenticated/user/tclip/transcripts"
    | "/_authenticated/onboarding/v2/"
    | "/_authenticated/user/apps/"
    | "/_authenticated/user/dsp/"
    | "/_authenticated/user/pricing/"
    | "/_authenticated/user/productlaunch/"
    | "/_authenticated/user/programs/"
    | "/_authenticated/user/searchqueryperformance/"
    | "/_authenticated/onboarding/v2/about/sales"
    | "/_authenticated/onboarding/v2/about/type"
    | "/_authenticated/user/advertising/programs/create"
    | "/_authenticated/user/amc/conversionchart/reports"
    | "/_authenticated/user/content/quality/org"
    | "/_authenticated/user/content/templates/$templateId"
    | "/_authenticated/user/dsp/$dspAdvertiser/dashboard"
    | "/_authenticated/user/merchandising/category/$category"
    | "/_authenticated/user/merchandising/coupons/$coupon"
    | "/_authenticated/user/merchandising/parent/$parentAsin"
    | "/_authenticated/user/merchandising/product/$product"
    | "/_authenticated/user/pricing/plan/$plan"
    | "/_authenticated/user/productlaunch/launches/$id"
    | "/_authenticated/user/programs/edit/$id"
    | "/_authenticated/user/report/organization/summary"
    | "/_authenticated/user/staff/reportcard/$org_id"
    | "/_authenticated/user/staff/user-activity/$org_id"
    | "/_authenticated/user/staff/walmart/profiles"
    | "/_authenticated/user/staff/workflows/$workflow_id"
    | "/_authenticated/user/tclip/agent/$agentId"
    | "/_authenticated/user/advertising/dashboard/"
    | "/_authenticated/user/advertising/programs/"
    | "/_authenticated/user/amc/dashboard/"
    | "/_authenticated/user/merchandising/coupons/"
    | "/_authenticated/user/pl/report/"
    | "/_authenticated/user/pricing/dashboard/"
    | "/_authenticated/user/pricing/management/"
    | "/_authenticated/user/staff/reportcard/"
    | "/_authenticated/user/staff/user-activity/"
    | "/_authenticated/user/staff/workflows/"
    | "/_authenticated/user/advertising/dashboard/ads/$id"
    | "/_authenticated/user/advertising/dashboard/category/$id"
    | "/_authenticated/user/advertising/programs/edit/$id"
    | "/_authenticated/user/amc/dashboard/reports/$id"
    | "/_authenticated/user/content/quality/category/$category"
    | "/_authenticated/user/dsp/$dspAdvertiser/lineitems/$id"
    | "/_authenticated/user/dsp/$dspAdvertiser/orders/$id"
    | "/_authenticated/user/pricing/dashboard/category/$category"
    | "/_authenticated/user/pricing/management/category/$category"
    | "/_authenticated/user/amc/dashboard/reports/details/$id";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren;
  PdfRouteRoute: typeof PdfRouteRouteWithChildren;
  SignupRoute: typeof SignupRoute;
  ConnectTiktokRoute: typeof ConnectTiktokRoute;
  ShopifyInstallRoute: typeof ShopifyInstallRoute;
  SigninResetpasswordRoute: typeof SigninResetpasswordRoute;
  SigninIndexRoute: typeof SigninIndexRoute;
  OauthAmazonAdvertisingRoute: typeof OauthAmazonAdvertisingRoute;
  OauthAmazonSpapiRoute: typeof OauthAmazonSpapiRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/pdf": {
      id: "/pdf";
      path: "/pdf";
      fullPath: "/pdf";
      preLoaderRoute: typeof PdfRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signup": {
      id: "/signup";
      path: "/signup";
      fullPath: "/signup";
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/user": {
      id: "/_authenticated/user";
      path: "/user";
      fullPath: "/user";
      preLoaderRoute: typeof AuthenticatedUserRouteRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/connect/tiktok": {
      id: "/connect/tiktok";
      path: "/connect/tiktok";
      fullPath: "/connect/tiktok";
      preLoaderRoute: typeof ConnectTiktokRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/shopify/install": {
      id: "/shopify/install";
      path: "/shopify/install";
      fullPath: "/shopify/install";
      preLoaderRoute: typeof ShopifyInstallRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signin/": {
      id: "/signin/";
      path: "/signin";
      fullPath: "/signin/";
      preLoaderRoute: typeof SigninIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signin/resetpassword": {
      id: "/signin/resetpassword";
      path: "/signin/resetpassword";
      fullPath: "/signin/resetpassword";
      preLoaderRoute: typeof SigninResetpasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/mcp/authorize": {
      id: "/_authenticated/mcp/authorize";
      path: "/mcp/authorize";
      fullPath: "/mcp/authorize";
      preLoaderRoute: typeof AuthenticatedMcpAuthorizeRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/onboarding/v2": {
      id: "/_authenticated/onboarding/v2";
      path: "/onboarding/v2";
      fullPath: "/onboarding/v2";
      preLoaderRoute: typeof AuthenticatedOnboardingV2RouteRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/user/": {
      id: "/_authenticated/user/";
      path: "/";
      fullPath: "/user/";
      preLoaderRoute: typeof AuthenticatedUserIndexRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/amzsummary": {
      id: "/_authenticated/user/amzsummary";
      path: "/amzsummary";
      fullPath: "/user/amzsummary";
      preLoaderRoute: typeof AuthenticatedUserAmzsummaryRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/applications": {
      id: "/_authenticated/user/applications";
      path: "/applications";
      fullPath: "/user/applications";
      preLoaderRoute: typeof AuthenticatedUserApplicationsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/billing": {
      id: "/_authenticated/user/billing";
      path: "/billing";
      fullPath: "/user/billing";
      preLoaderRoute: typeof AuthenticatedUserBillingRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/categorymanagement": {
      id: "/_authenticated/user/categorymanagement";
      path: "/categorymanagement";
      fullPath: "/user/categorymanagement";
      preLoaderRoute: typeof AuthenticatedUserCategorymanagementRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/chromeaccess": {
      id: "/_authenticated/user/chromeaccess";
      path: "/chromeaccess";
      fullPath: "/user/chromeaccess";
      preLoaderRoute: typeof AuthenticatedUserChromeaccessRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/dashboard": {
      id: "/_authenticated/user/dashboard";
      path: "/dashboard";
      fullPath: "/user/dashboard";
      preLoaderRoute: typeof AuthenticatedUserDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/data-status": {
      id: "/_authenticated/user/data-status";
      path: "/data-status";
      fullPath: "/user/data-status";
      preLoaderRoute: typeof AuthenticatedUserDataStatusRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/goals": {
      id: "/_authenticated/user/goals";
      path: "/goals";
      fullPath: "/user/goals";
      preLoaderRoute: typeof AuthenticatedUserGoalsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/live": {
      id: "/_authenticated/user/live";
      path: "/live";
      fullPath: "/user/live";
      preLoaderRoute: typeof AuthenticatedUserLiveRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/mcp": {
      id: "/_authenticated/user/mcp";
      path: "/mcp";
      fullPath: "/user/mcp";
      preLoaderRoute: typeof AuthenticatedUserMcpRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/merchandising": {
      id: "/_authenticated/user/merchandising";
      path: "/merchandising";
      fullPath: "/user/merchandising";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/payment": {
      id: "/_authenticated/user/payment";
      path: "/payment";
      fullPath: "/user/payment";
      preLoaderRoute: typeof AuthenticatedUserPaymentRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/pl": {
      id: "/_authenticated/user/pl";
      path: "/pl";
      fullPath: "/user/pl";
      preLoaderRoute: typeof AuthenticatedUserPlRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/plans": {
      id: "/_authenticated/user/plans";
      path: "/plans";
      fullPath: "/user/plans";
      preLoaderRoute: typeof AuthenticatedUserPlansRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/pricing": {
      id: "/_authenticated/user/pricing";
      path: "/pricing";
      fullPath: "/user/pricing";
      preLoaderRoute: typeof AuthenticatedUserPricingRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/productlaunch": {
      id: "/_authenticated/user/productlaunch";
      path: "/productlaunch";
      fullPath: "/user/productlaunch";
      preLoaderRoute: typeof AuthenticatedUserProductlaunchRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/programs": {
      id: "/_authenticated/user/programs";
      path: "/programs";
      fullPath: "/user/programs";
      preLoaderRoute: typeof AuthenticatedUserProgramsRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/searchanalytics": {
      id: "/_authenticated/user/searchanalytics";
      path: "/searchanalytics";
      fullPath: "/user/searchanalytics";
      preLoaderRoute: typeof AuthenticatedUserSearchanalyticsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/searchqueryperformance": {
      id: "/_authenticated/user/searchqueryperformance";
      path: "/searchqueryperformance";
      fullPath: "/user/searchqueryperformance";
      preLoaderRoute: typeof AuthenticatedUserSearchqueryperformanceRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/settings": {
      id: "/_authenticated/user/settings";
      path: "/settings";
      fullPath: "/user/settings";
      preLoaderRoute: typeof AuthenticatedUserSettingsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/shopifysummary": {
      id: "/_authenticated/user/shopifysummary";
      path: "/shopifysummary";
      fullPath: "/user/shopifysummary";
      preLoaderRoute: typeof AuthenticatedUserShopifysummaryRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/shopperinsightsV2": {
      id: "/_authenticated/user/shopperinsightsV2";
      path: "/shopperinsightsV2";
      fullPath: "/user/shopperinsightsV2";
      preLoaderRoute: typeof AuthenticatedUserShopperinsightsV2RouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/tagmanagement": {
      id: "/_authenticated/user/tagmanagement";
      path: "/tagmanagement";
      fullPath: "/user/tagmanagement";
      preLoaderRoute: typeof AuthenticatedUserTagmanagementRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/tclip": {
      id: "/_authenticated/user/tclip";
      path: "/tclip";
      fullPath: "/user/tclip";
      preLoaderRoute: typeof AuthenticatedUserTclipRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/tickets": {
      id: "/_authenticated/user/tickets";
      path: "/tickets";
      fullPath: "/user/tickets";
      preLoaderRoute: typeof AuthenticatedUserTicketsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/trmnl": {
      id: "/_authenticated/user/trmnl";
      path: "/trmnl";
      fullPath: "/user/trmnl";
      preLoaderRoute: typeof AuthenticatedUserTrmnlRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/uploads": {
      id: "/_authenticated/user/uploads";
      path: "/uploads";
      fullPath: "/user/uploads";
      preLoaderRoute: typeof AuthenticatedUserUploadsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/usermanagement": {
      id: "/_authenticated/user/usermanagement";
      path: "/usermanagement";
      fullPath: "/user/usermanagement";
      preLoaderRoute: typeof AuthenticatedUserUsermanagementRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/verify": {
      id: "/_authenticated/user/verify";
      path: "/verify";
      fullPath: "/user/verify";
      preLoaderRoute: typeof AuthenticatedUserVerifyRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/videogen": {
      id: "/_authenticated/user/videogen";
      path: "/videogen";
      fullPath: "/user/videogen";
      preLoaderRoute: typeof AuthenticatedUserVideogenRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/walmartsummary": {
      id: "/_authenticated/user/walmartsummary";
      path: "/walmartsummary";
      fullPath: "/user/walmartsummary";
      preLoaderRoute: typeof AuthenticatedUserWalmartsummaryRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/walmart/install": {
      id: "/_authenticated/walmart/install";
      path: "/walmart/install";
      fullPath: "/walmart/install";
      preLoaderRoute: typeof AuthenticatedWalmartInstallRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/oauth/amazon/advertising": {
      id: "/oauth/amazon/advertising";
      path: "/oauth/amazon/advertising";
      fullPath: "/oauth/amazon/advertising";
      preLoaderRoute: typeof OauthAmazonAdvertisingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oauth/amazon/spapi": {
      id: "/oauth/amazon/spapi";
      path: "/oauth/amazon/spapi";
      fullPath: "/oauth/amazon/spapi";
      preLoaderRoute: typeof OauthAmazonSpapiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/onboarding/v2/": {
      id: "/_authenticated/onboarding/v2/";
      path: "/";
      fullPath: "/onboarding/v2/";
      preLoaderRoute: typeof AuthenticatedOnboardingV2IndexRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/channel": {
      id: "/_authenticated/onboarding/v2/channel";
      path: "/channel";
      fullPath: "/onboarding/v2/channel";
      preLoaderRoute: typeof AuthenticatedOnboardingV2ChannelRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/connect": {
      id: "/_authenticated/onboarding/v2/connect";
      path: "/connect";
      fullPath: "/onboarding/v2/connect";
      preLoaderRoute: typeof AuthenticatedOnboardingV2ConnectRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/profiles": {
      id: "/_authenticated/onboarding/v2/profiles";
      path: "/profiles";
      fullPath: "/onboarding/v2/profiles";
      preLoaderRoute: typeof AuthenticatedOnboardingV2ProfilesRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/sellertype": {
      id: "/_authenticated/onboarding/v2/sellertype";
      path: "/sellertype";
      fullPath: "/onboarding/v2/sellertype";
      preLoaderRoute: typeof AuthenticatedOnboardingV2SellertypeRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/summary": {
      id: "/_authenticated/onboarding/v2/summary";
      path: "/summary";
      fullPath: "/onboarding/v2/summary";
      preLoaderRoute: typeof AuthenticatedOnboardingV2SummaryRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/user/advertising/programs": {
      id: "/_authenticated/user/advertising/programs";
      path: "/advertising/programs";
      fullPath: "/user/advertising/programs";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingProgramsRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/advertising/settings": {
      id: "/_authenticated/user/advertising/settings";
      path: "/advertising/settings";
      fullPath: "/user/advertising/settings";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingSettingsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/agency/dashboard": {
      id: "/_authenticated/user/agency/dashboard";
      path: "/agency/dashboard";
      fullPath: "/user/agency/dashboard";
      preLoaderRoute: typeof AuthenticatedUserAgencyDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/amc/configuration": {
      id: "/_authenticated/user/amc/configuration";
      path: "/amc/configuration";
      fullPath: "/user/amc/configuration";
      preLoaderRoute: typeof AuthenticatedUserAmcConfigurationRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/amc/shopperinsightsV2": {
      id: "/_authenticated/user/amc/shopperinsightsV2";
      path: "/amc/shopperinsightsV2";
      fullPath: "/user/amc/shopperinsightsV2";
      preLoaderRoute: typeof AuthenticatedUserAmcShopperinsightsV2RouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/apps/": {
      id: "/_authenticated/user/apps/";
      path: "/apps";
      fullPath: "/user/apps/";
      preLoaderRoute: typeof AuthenticatedUserAppsIndexRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/apps/shopify": {
      id: "/_authenticated/user/apps/shopify";
      path: "/apps/shopify";
      fullPath: "/user/apps/shopify";
      preLoaderRoute: typeof AuthenticatedUserAppsShopifyRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/audience/dashboard": {
      id: "/_authenticated/user/audience/dashboard";
      path: "/audience/dashboard";
      fullPath: "/user/audience/dashboard";
      preLoaderRoute: typeof AuthenticatedUserAudienceDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/content/seo": {
      id: "/_authenticated/user/content/seo";
      path: "/content/seo";
      fullPath: "/user/content/seo";
      preLoaderRoute: typeof AuthenticatedUserContentSeoRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/dsp/": {
      id: "/_authenticated/user/dsp/";
      path: "/dsp";
      fullPath: "/user/dsp/";
      preLoaderRoute: typeof AuthenticatedUserDspIndexRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/live/report": {
      id: "/_authenticated/user/live/report";
      path: "/report";
      fullPath: "/user/live/report";
      preLoaderRoute: typeof AuthenticatedUserLiveReportRouteImport;
      parentRoute: typeof AuthenticatedUserLiveRouteRoute;
    };
    "/_authenticated/user/merchandising/dashboard": {
      id: "/_authenticated/user/merchandising/dashboard";
      path: "/dashboard";
      fullPath: "/user/merchandising/dashboard";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/merchandising/promotions": {
      id: "/_authenticated/user/merchandising/promotions";
      path: "/promotions";
      fullPath: "/user/merchandising/promotions";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingPromotionsRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/pricing/": {
      id: "/_authenticated/user/pricing/";
      path: "/";
      fullPath: "/user/pricing/";
      preLoaderRoute: typeof AuthenticatedUserPricingIndexRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/buybox": {
      id: "/_authenticated/user/pricing/buybox";
      path: "/buybox";
      fullPath: "/user/pricing/buybox";
      preLoaderRoute: typeof AuthenticatedUserPricingBuyboxRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/changes": {
      id: "/_authenticated/user/pricing/changes";
      path: "/changes";
      fullPath: "/user/pricing/changes";
      preLoaderRoute: typeof AuthenticatedUserPricingChangesRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/configuration": {
      id: "/_authenticated/user/pricing/configuration";
      path: "/configuration";
      fullPath: "/user/pricing/configuration";
      preLoaderRoute: typeof AuthenticatedUserPricingConfigurationRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/forecast": {
      id: "/_authenticated/user/pricing/forecast";
      path: "/forecast";
      fullPath: "/user/pricing/forecast";
      preLoaderRoute: typeof AuthenticatedUserPricingForecastRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/productlaunch/": {
      id: "/_authenticated/user/productlaunch/";
      path: "/";
      fullPath: "/user/productlaunch/";
      preLoaderRoute: typeof AuthenticatedUserProductlaunchIndexRouteImport;
      parentRoute: typeof AuthenticatedUserProductlaunchRouteRoute;
    };
    "/_authenticated/user/productlaunch/new": {
      id: "/_authenticated/user/productlaunch/new";
      path: "/new";
      fullPath: "/user/productlaunch/new";
      preLoaderRoute: typeof AuthenticatedUserProductlaunchNewRouteImport;
      parentRoute: typeof AuthenticatedUserProductlaunchRouteRoute;
    };
    "/_authenticated/user/programs/": {
      id: "/_authenticated/user/programs/";
      path: "/";
      fullPath: "/user/programs/";
      preLoaderRoute: typeof AuthenticatedUserProgramsIndexRouteImport;
      parentRoute: typeof AuthenticatedUserProgramsRouteRoute;
    };
    "/_authenticated/user/programs/create": {
      id: "/_authenticated/user/programs/create";
      path: "/create";
      fullPath: "/user/programs/create";
      preLoaderRoute: typeof AuthenticatedUserProgramsCreateRouteImport;
      parentRoute: typeof AuthenticatedUserProgramsRouteRoute;
    };
    "/_authenticated/user/report/advertisement": {
      id: "/_authenticated/user/report/advertisement";
      path: "/report/advertisement";
      fullPath: "/user/report/advertisement";
      preLoaderRoute: typeof AuthenticatedUserReportAdvertisementRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/audience": {
      id: "/_authenticated/user/report/audience";
      path: "/report/audience";
      fullPath: "/user/report/audience";
      preLoaderRoute: typeof AuthenticatedUserReportAudienceRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/export": {
      id: "/_authenticated/user/report/export";
      path: "/report/export";
      fullPath: "/user/report/export";
      preLoaderRoute: typeof AuthenticatedUserReportExportRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/pricing_plan": {
      id: "/_authenticated/user/report/pricing_plan";
      path: "/report/pricing_plan";
      fullPath: "/user/report/pricing_plan";
      preLoaderRoute: typeof AuthenticatedUserReportPricing_planRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/product": {
      id: "/_authenticated/user/report/product";
      path: "/report/product";
      fullPath: "/user/report/product";
      preLoaderRoute: typeof AuthenticatedUserReportProductRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/product_ad": {
      id: "/_authenticated/user/report/product_ad";
      path: "/report/product_ad";
      fullPath: "/user/report/product_ad";
      preLoaderRoute: typeof AuthenticatedUserReportProduct_adRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/sqpr_report": {
      id: "/_authenticated/user/report/sqpr_report";
      path: "/report/sqpr_report";
      fullPath: "/user/report/sqpr_report";
      preLoaderRoute: typeof AuthenticatedUserReportSqpr_reportRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/str_report": {
      id: "/_authenticated/user/report/str_report";
      path: "/report/str_report";
      fullPath: "/user/report/str_report";
      preLoaderRoute: typeof AuthenticatedUserReportStr_reportRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/report/target": {
      id: "/_authenticated/user/report/target";
      path: "/report/target";
      fullPath: "/user/report/target";
      preLoaderRoute: typeof AuthenticatedUserReportTargetRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/searchqueryperformance/": {
      id: "/_authenticated/user/searchqueryperformance/";
      path: "/";
      fullPath: "/user/searchqueryperformance/";
      preLoaderRoute: typeof AuthenticatedUserSearchqueryperformanceIndexRouteImport;
      parentRoute: typeof AuthenticatedUserSearchqueryperformanceRouteRoute;
    };
    "/_authenticated/user/searchqueryperformance/$id": {
      id: "/_authenticated/user/searchqueryperformance/$id";
      path: "/$id";
      fullPath: "/user/searchqueryperformance/$id";
      preLoaderRoute: typeof AuthenticatedUserSearchqueryperformanceIdRouteImport;
      parentRoute: typeof AuthenticatedUserSearchqueryperformanceRouteRoute;
    };
    "/_authenticated/user/staff/dashboard": {
      id: "/_authenticated/user/staff/dashboard";
      path: "/staff/dashboard";
      fullPath: "/user/staff/dashboard";
      preLoaderRoute: typeof AuthenticatedUserStaffDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/staff/reportcard": {
      id: "/_authenticated/user/staff/reportcard";
      path: "/staff/reportcard";
      fullPath: "/user/staff/reportcard";
      preLoaderRoute: typeof AuthenticatedUserStaffReportcardRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/staff/user-activity": {
      id: "/_authenticated/user/staff/user-activity";
      path: "/staff/user-activity";
      fullPath: "/user/staff/user-activity";
      preLoaderRoute: typeof AuthenticatedUserStaffUserActivityRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/staff/workflows": {
      id: "/_authenticated/user/staff/workflows";
      path: "/staff/workflows";
      fullPath: "/user/staff/workflows";
      preLoaderRoute: typeof AuthenticatedUserStaffWorkflowsRouteRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/tclip/agents": {
      id: "/_authenticated/user/tclip/agents";
      path: "/agents";
      fullPath: "/user/tclip/agents";
      preLoaderRoute: typeof AuthenticatedUserTclipAgentsRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/tclip/playground": {
      id: "/_authenticated/user/tclip/playground";
      path: "/playground";
      fullPath: "/user/tclip/playground";
      preLoaderRoute: typeof AuthenticatedUserTclipPlaygroundLazyRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/tclip/tasks": {
      id: "/_authenticated/user/tclip/tasks";
      path: "/tasks";
      fullPath: "/user/tclip/tasks";
      preLoaderRoute: typeof AuthenticatedUserTclipTasksRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/tclip/templates": {
      id: "/_authenticated/user/tclip/templates";
      path: "/templates";
      fullPath: "/user/tclip/templates";
      preLoaderRoute: typeof AuthenticatedUserTclipTemplatesLazyRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/tclip/transcripts": {
      id: "/_authenticated/user/tclip/transcripts";
      path: "/transcripts";
      fullPath: "/user/tclip/transcripts";
      preLoaderRoute: typeof AuthenticatedUserTclipTranscriptsLazyRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/userdetails/$id": {
      id: "/_authenticated/user/userdetails/$id";
      path: "/userdetails/$id";
      fullPath: "/user/userdetails/$id";
      preLoaderRoute: typeof AuthenticatedUserUserdetailsIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/pdf/report/organization/summary": {
      id: "/pdf/report/organization/summary";
      path: "/report/organization/summary";
      fullPath: "/pdf/report/organization/summary";
      preLoaderRoute: typeof PdfReportOrganizationSummaryRouteImport;
      parentRoute: typeof PdfRouteRoute;
    };
    "/_authenticated/onboarding/v2/about/sales": {
      id: "/_authenticated/onboarding/v2/about/sales";
      path: "/about/sales";
      fullPath: "/onboarding/v2/about/sales";
      preLoaderRoute: typeof AuthenticatedOnboardingV2AboutSalesRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/onboarding/v2/about/type": {
      id: "/_authenticated/onboarding/v2/about/type";
      path: "/about/type";
      fullPath: "/onboarding/v2/about/type";
      preLoaderRoute: typeof AuthenticatedOnboardingV2AboutTypeRouteImport;
      parentRoute: typeof AuthenticatedOnboardingV2RouteRoute;
    };
    "/_authenticated/user/advertising/dashboard/": {
      id: "/_authenticated/user/advertising/dashboard/";
      path: "/advertising/dashboard";
      fullPath: "/user/advertising/dashboard/";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingDashboardIndexRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/advertising/programs/": {
      id: "/_authenticated/user/advertising/programs/";
      path: "/";
      fullPath: "/user/advertising/programs/";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingProgramsIndexRouteImport;
      parentRoute: typeof AuthenticatedUserAdvertisingProgramsRouteRoute;
    };
    "/_authenticated/user/advertising/programs/create": {
      id: "/_authenticated/user/advertising/programs/create";
      path: "/create";
      fullPath: "/user/advertising/programs/create";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingProgramsCreateRouteImport;
      parentRoute: typeof AuthenticatedUserAdvertisingProgramsRouteRoute;
    };
    "/_authenticated/user/amc/conversionchart/reports": {
      id: "/_authenticated/user/amc/conversionchart/reports";
      path: "/amc/conversionchart/reports";
      fullPath: "/user/amc/conversionchart/reports";
      preLoaderRoute: typeof AuthenticatedUserAmcConversionchartReportsRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/amc/dashboard/": {
      id: "/_authenticated/user/amc/dashboard/";
      path: "/amc/dashboard";
      fullPath: "/user/amc/dashboard/";
      preLoaderRoute: typeof AuthenticatedUserAmcDashboardIndexRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/content/quality/org": {
      id: "/_authenticated/user/content/quality/org";
      path: "/content/quality/org";
      fullPath: "/user/content/quality/org";
      preLoaderRoute: typeof AuthenticatedUserContentQualityOrgRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/content/templates/$templateId": {
      id: "/_authenticated/user/content/templates/$templateId";
      path: "/content/templates/$templateId";
      fullPath: "/user/content/templates/$templateId";
      preLoaderRoute: typeof AuthenticatedUserContentTemplatesTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/dsp/$dspAdvertiser/dashboard": {
      id: "/_authenticated/user/dsp/$dspAdvertiser/dashboard";
      path: "/dsp/$dspAdvertiser/dashboard";
      fullPath: "/user/dsp/$dspAdvertiser/dashboard";
      preLoaderRoute: typeof AuthenticatedUserDspDspAdvertiserDashboardRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/merchandising/category/$category": {
      id: "/_authenticated/user/merchandising/category/$category";
      path: "/category/$category";
      fullPath: "/user/merchandising/category/$category";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingCategoryCategoryRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/merchandising/coupons/": {
      id: "/_authenticated/user/merchandising/coupons/";
      path: "/coupons";
      fullPath: "/user/merchandising/coupons/";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingCouponsIndexRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/merchandising/coupons/$coupon": {
      id: "/_authenticated/user/merchandising/coupons/$coupon";
      path: "/coupons/$coupon";
      fullPath: "/user/merchandising/coupons/$coupon";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingCouponsCouponRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/merchandising/parent/$parentAsin": {
      id: "/_authenticated/user/merchandising/parent/$parentAsin";
      path: "/parent/$parentAsin";
      fullPath: "/user/merchandising/parent/$parentAsin";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingParentParentAsinRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/merchandising/product/$product": {
      id: "/_authenticated/user/merchandising/product/$product";
      path: "/product/$product";
      fullPath: "/user/merchandising/product/$product";
      preLoaderRoute: typeof AuthenticatedUserMerchandisingProductProductRouteImport;
      parentRoute: typeof AuthenticatedUserMerchandisingRouteRoute;
    };
    "/_authenticated/user/pl/report/": {
      id: "/_authenticated/user/pl/report/";
      path: "/report";
      fullPath: "/user/pl/report/";
      preLoaderRoute: typeof AuthenticatedUserPlReportIndexRouteImport;
      parentRoute: typeof AuthenticatedUserPlRouteRoute;
    };
    "/_authenticated/user/pricing/dashboard/": {
      id: "/_authenticated/user/pricing/dashboard/";
      path: "/dashboard";
      fullPath: "/user/pricing/dashboard/";
      preLoaderRoute: typeof AuthenticatedUserPricingDashboardIndexRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/management/": {
      id: "/_authenticated/user/pricing/management/";
      path: "/management";
      fullPath: "/user/pricing/management/";
      preLoaderRoute: typeof AuthenticatedUserPricingManagementIndexRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/plan/$plan": {
      id: "/_authenticated/user/pricing/plan/$plan";
      path: "/plan/$plan";
      fullPath: "/user/pricing/plan/$plan";
      preLoaderRoute: typeof AuthenticatedUserPricingPlanPlanRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/productlaunch/launches/$id": {
      id: "/_authenticated/user/productlaunch/launches/$id";
      path: "/launches/$id";
      fullPath: "/user/productlaunch/launches/$id";
      preLoaderRoute: typeof AuthenticatedUserProductlaunchLaunchesIdRouteImport;
      parentRoute: typeof AuthenticatedUserProductlaunchRouteRoute;
    };
    "/_authenticated/user/programs/edit/$id": {
      id: "/_authenticated/user/programs/edit/$id";
      path: "/edit/$id";
      fullPath: "/user/programs/edit/$id";
      preLoaderRoute: typeof AuthenticatedUserProgramsEditIdRouteImport;
      parentRoute: typeof AuthenticatedUserProgramsRouteRoute;
    };
    "/_authenticated/user/report/organization/summary": {
      id: "/_authenticated/user/report/organization/summary";
      path: "/report/organization/summary";
      fullPath: "/user/report/organization/summary";
      preLoaderRoute: typeof AuthenticatedUserReportOrganizationSummaryRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/staff/reportcard/": {
      id: "/_authenticated/user/staff/reportcard/";
      path: "/";
      fullPath: "/user/staff/reportcard/";
      preLoaderRoute: typeof AuthenticatedUserStaffReportcardIndexRouteImport;
      parentRoute: typeof AuthenticatedUserStaffReportcardRouteRoute;
    };
    "/_authenticated/user/staff/reportcard/$org_id": {
      id: "/_authenticated/user/staff/reportcard/$org_id";
      path: "/$org_id";
      fullPath: "/user/staff/reportcard/$org_id";
      preLoaderRoute: typeof AuthenticatedUserStaffReportcardOrg_idRouteImport;
      parentRoute: typeof AuthenticatedUserStaffReportcardRouteRoute;
    };
    "/_authenticated/user/staff/user-activity/": {
      id: "/_authenticated/user/staff/user-activity/";
      path: "/";
      fullPath: "/user/staff/user-activity/";
      preLoaderRoute: typeof AuthenticatedUserStaffUserActivityIndexRouteImport;
      parentRoute: typeof AuthenticatedUserStaffUserActivityRouteRoute;
    };
    "/_authenticated/user/staff/user-activity/$org_id": {
      id: "/_authenticated/user/staff/user-activity/$org_id";
      path: "/$org_id";
      fullPath: "/user/staff/user-activity/$org_id";
      preLoaderRoute: typeof AuthenticatedUserStaffUserActivityOrg_idRouteImport;
      parentRoute: typeof AuthenticatedUserStaffUserActivityRouteRoute;
    };
    "/_authenticated/user/staff/walmart/profiles": {
      id: "/_authenticated/user/staff/walmart/profiles";
      path: "/staff/walmart/profiles";
      fullPath: "/user/staff/walmart/profiles";
      preLoaderRoute: typeof AuthenticatedUserStaffWalmartProfilesRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/staff/workflows/": {
      id: "/_authenticated/user/staff/workflows/";
      path: "/";
      fullPath: "/user/staff/workflows/";
      preLoaderRoute: typeof AuthenticatedUserStaffWorkflowsIndexRouteImport;
      parentRoute: typeof AuthenticatedUserStaffWorkflowsRouteRoute;
    };
    "/_authenticated/user/staff/workflows/$workflow_id": {
      id: "/_authenticated/user/staff/workflows/$workflow_id";
      path: "/$workflow_id";
      fullPath: "/user/staff/workflows/$workflow_id";
      preLoaderRoute: typeof AuthenticatedUserStaffWorkflowsWorkflow_idRouteImport;
      parentRoute: typeof AuthenticatedUserStaffWorkflowsRouteRoute;
    };
    "/_authenticated/user/tclip/agent/$agentId": {
      id: "/_authenticated/user/tclip/agent/$agentId";
      path: "/agent/$agentId";
      fullPath: "/user/tclip/agent/$agentId";
      preLoaderRoute: typeof AuthenticatedUserTclipAgentAgentIdLazyRouteImport;
      parentRoute: typeof AuthenticatedUserTclipRouteRoute;
    };
    "/_authenticated/user/advertising/dashboard/ads/$id": {
      id: "/_authenticated/user/advertising/dashboard/ads/$id";
      path: "/advertising/dashboard/ads/$id";
      fullPath: "/user/advertising/dashboard/ads/$id";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingDashboardAdsIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/advertising/dashboard/category/$id": {
      id: "/_authenticated/user/advertising/dashboard/category/$id";
      path: "/advertising/dashboard/category/$id";
      fullPath: "/user/advertising/dashboard/category/$id";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingDashboardCategoryIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/advertising/programs/edit/$id": {
      id: "/_authenticated/user/advertising/programs/edit/$id";
      path: "/edit/$id";
      fullPath: "/user/advertising/programs/edit/$id";
      preLoaderRoute: typeof AuthenticatedUserAdvertisingProgramsEditIdRouteImport;
      parentRoute: typeof AuthenticatedUserAdvertisingProgramsRouteRoute;
    };
    "/_authenticated/user/amc/dashboard/reports/$id": {
      id: "/_authenticated/user/amc/dashboard/reports/$id";
      path: "/amc/dashboard/reports/$id";
      fullPath: "/user/amc/dashboard/reports/$id";
      preLoaderRoute: typeof AuthenticatedUserAmcDashboardReportsIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/content/quality/category/$category": {
      id: "/_authenticated/user/content/quality/category/$category";
      path: "/content/quality/category/$category";
      fullPath: "/user/content/quality/category/$category";
      preLoaderRoute: typeof AuthenticatedUserContentQualityCategoryCategoryRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/dsp/$dspAdvertiser/lineitems/$id": {
      id: "/_authenticated/user/dsp/$dspAdvertiser/lineitems/$id";
      path: "/dsp/$dspAdvertiser/lineitems/$id";
      fullPath: "/user/dsp/$dspAdvertiser/lineitems/$id";
      preLoaderRoute: typeof AuthenticatedUserDspDspAdvertiserLineitemsIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/dsp/$dspAdvertiser/orders/$id": {
      id: "/_authenticated/user/dsp/$dspAdvertiser/orders/$id";
      path: "/dsp/$dspAdvertiser/orders/$id";
      fullPath: "/user/dsp/$dspAdvertiser/orders/$id";
      preLoaderRoute: typeof AuthenticatedUserDspDspAdvertiserOrdersIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
    "/_authenticated/user/pricing/dashboard/category/$category": {
      id: "/_authenticated/user/pricing/dashboard/category/$category";
      path: "/dashboard/category/$category";
      fullPath: "/user/pricing/dashboard/category/$category";
      preLoaderRoute: typeof AuthenticatedUserPricingDashboardCategoryCategoryRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/pricing/management/category/$category": {
      id: "/_authenticated/user/pricing/management/category/$category";
      path: "/management/category/$category";
      fullPath: "/user/pricing/management/category/$category";
      preLoaderRoute: typeof AuthenticatedUserPricingManagementCategoryCategoryRouteImport;
      parentRoute: typeof AuthenticatedUserPricingRouteRoute;
    };
    "/_authenticated/user/amc/dashboard/reports/details/$id": {
      id: "/_authenticated/user/amc/dashboard/reports/details/$id";
      path: "/amc/dashboard/reports/details/$id";
      fullPath: "/user/amc/dashboard/reports/details/$id";
      preLoaderRoute: typeof AuthenticatedUserAmcDashboardReportsDetailsIdRouteImport;
      parentRoute: typeof AuthenticatedUserRouteRoute;
    };
  }
}

interface AuthenticatedUserLiveRouteRouteChildren {
  AuthenticatedUserLiveReportRoute: typeof AuthenticatedUserLiveReportRoute;
}

const AuthenticatedUserLiveRouteRouteChildren: AuthenticatedUserLiveRouteRouteChildren =
  {
    AuthenticatedUserLiveReportRoute: AuthenticatedUserLiveReportRoute,
  };

const AuthenticatedUserLiveRouteRouteWithChildren =
  AuthenticatedUserLiveRouteRoute._addFileChildren(
    AuthenticatedUserLiveRouteRouteChildren,
  );

interface AuthenticatedUserMerchandisingRouteRouteChildren {
  AuthenticatedUserMerchandisingDashboardRoute: typeof AuthenticatedUserMerchandisingDashboardRoute;
  AuthenticatedUserMerchandisingPromotionsRoute: typeof AuthenticatedUserMerchandisingPromotionsRoute;
  AuthenticatedUserMerchandisingCategoryCategoryRoute: typeof AuthenticatedUserMerchandisingCategoryCategoryRoute;
  AuthenticatedUserMerchandisingCouponsCouponRoute: typeof AuthenticatedUserMerchandisingCouponsCouponRoute;
  AuthenticatedUserMerchandisingParentParentAsinRoute: typeof AuthenticatedUserMerchandisingParentParentAsinRoute;
  AuthenticatedUserMerchandisingProductProductRoute: typeof AuthenticatedUserMerchandisingProductProductRoute;
  AuthenticatedUserMerchandisingCouponsIndexRoute: typeof AuthenticatedUserMerchandisingCouponsIndexRoute;
}

const AuthenticatedUserMerchandisingRouteRouteChildren: AuthenticatedUserMerchandisingRouteRouteChildren =
  {
    AuthenticatedUserMerchandisingDashboardRoute:
      AuthenticatedUserMerchandisingDashboardRoute,
    AuthenticatedUserMerchandisingPromotionsRoute:
      AuthenticatedUserMerchandisingPromotionsRoute,
    AuthenticatedUserMerchandisingCategoryCategoryRoute:
      AuthenticatedUserMerchandisingCategoryCategoryRoute,
    AuthenticatedUserMerchandisingCouponsCouponRoute:
      AuthenticatedUserMerchandisingCouponsCouponRoute,
    AuthenticatedUserMerchandisingParentParentAsinRoute:
      AuthenticatedUserMerchandisingParentParentAsinRoute,
    AuthenticatedUserMerchandisingProductProductRoute:
      AuthenticatedUserMerchandisingProductProductRoute,
    AuthenticatedUserMerchandisingCouponsIndexRoute:
      AuthenticatedUserMerchandisingCouponsIndexRoute,
  };

const AuthenticatedUserMerchandisingRouteRouteWithChildren =
  AuthenticatedUserMerchandisingRouteRoute._addFileChildren(
    AuthenticatedUserMerchandisingRouteRouteChildren,
  );

interface AuthenticatedUserPlRouteRouteChildren {
  AuthenticatedUserPlReportIndexRoute: typeof AuthenticatedUserPlReportIndexRoute;
}

const AuthenticatedUserPlRouteRouteChildren: AuthenticatedUserPlRouteRouteChildren =
  {
    AuthenticatedUserPlReportIndexRoute: AuthenticatedUserPlReportIndexRoute,
  };

const AuthenticatedUserPlRouteRouteWithChildren =
  AuthenticatedUserPlRouteRoute._addFileChildren(
    AuthenticatedUserPlRouteRouteChildren,
  );

interface AuthenticatedUserPricingRouteRouteChildren {
  AuthenticatedUserPricingBuyboxRoute: typeof AuthenticatedUserPricingBuyboxRoute;
  AuthenticatedUserPricingChangesRoute: typeof AuthenticatedUserPricingChangesRoute;
  AuthenticatedUserPricingConfigurationRoute: typeof AuthenticatedUserPricingConfigurationRoute;
  AuthenticatedUserPricingForecastRoute: typeof AuthenticatedUserPricingForecastRoute;
  AuthenticatedUserPricingIndexRoute: typeof AuthenticatedUserPricingIndexRoute;
  AuthenticatedUserPricingPlanPlanRoute: typeof AuthenticatedUserPricingPlanPlanRoute;
  AuthenticatedUserPricingDashboardIndexRoute: typeof AuthenticatedUserPricingDashboardIndexRoute;
  AuthenticatedUserPricingManagementIndexRoute: typeof AuthenticatedUserPricingManagementIndexRoute;
  AuthenticatedUserPricingDashboardCategoryCategoryRoute: typeof AuthenticatedUserPricingDashboardCategoryCategoryRoute;
  AuthenticatedUserPricingManagementCategoryCategoryRoute: typeof AuthenticatedUserPricingManagementCategoryCategoryRoute;
}

const AuthenticatedUserPricingRouteRouteChildren: AuthenticatedUserPricingRouteRouteChildren =
  {
    AuthenticatedUserPricingBuyboxRoute: AuthenticatedUserPricingBuyboxRoute,
    AuthenticatedUserPricingChangesRoute: AuthenticatedUserPricingChangesRoute,
    AuthenticatedUserPricingConfigurationRoute:
      AuthenticatedUserPricingConfigurationRoute,
    AuthenticatedUserPricingForecastRoute:
      AuthenticatedUserPricingForecastRoute,
    AuthenticatedUserPricingIndexRoute: AuthenticatedUserPricingIndexRoute,
    AuthenticatedUserPricingPlanPlanRoute:
      AuthenticatedUserPricingPlanPlanRoute,
    AuthenticatedUserPricingDashboardIndexRoute:
      AuthenticatedUserPricingDashboardIndexRoute,
    AuthenticatedUserPricingManagementIndexRoute:
      AuthenticatedUserPricingManagementIndexRoute,
    AuthenticatedUserPricingDashboardCategoryCategoryRoute:
      AuthenticatedUserPricingDashboardCategoryCategoryRoute,
    AuthenticatedUserPricingManagementCategoryCategoryRoute:
      AuthenticatedUserPricingManagementCategoryCategoryRoute,
  };

const AuthenticatedUserPricingRouteRouteWithChildren =
  AuthenticatedUserPricingRouteRoute._addFileChildren(
    AuthenticatedUserPricingRouteRouteChildren,
  );

interface AuthenticatedUserProductlaunchRouteRouteChildren {
  AuthenticatedUserProductlaunchNewRoute: typeof AuthenticatedUserProductlaunchNewRoute;
  AuthenticatedUserProductlaunchIndexRoute: typeof AuthenticatedUserProductlaunchIndexRoute;
  AuthenticatedUserProductlaunchLaunchesIdRoute: typeof AuthenticatedUserProductlaunchLaunchesIdRoute;
}

const AuthenticatedUserProductlaunchRouteRouteChildren: AuthenticatedUserProductlaunchRouteRouteChildren =
  {
    AuthenticatedUserProductlaunchNewRoute:
      AuthenticatedUserProductlaunchNewRoute,
    AuthenticatedUserProductlaunchIndexRoute:
      AuthenticatedUserProductlaunchIndexRoute,
    AuthenticatedUserProductlaunchLaunchesIdRoute:
      AuthenticatedUserProductlaunchLaunchesIdRoute,
  };

const AuthenticatedUserProductlaunchRouteRouteWithChildren =
  AuthenticatedUserProductlaunchRouteRoute._addFileChildren(
    AuthenticatedUserProductlaunchRouteRouteChildren,
  );

interface AuthenticatedUserProgramsRouteRouteChildren {
  AuthenticatedUserProgramsCreateRoute: typeof AuthenticatedUserProgramsCreateRoute;
  AuthenticatedUserProgramsIndexRoute: typeof AuthenticatedUserProgramsIndexRoute;
  AuthenticatedUserProgramsEditIdRoute: typeof AuthenticatedUserProgramsEditIdRoute;
}

const AuthenticatedUserProgramsRouteRouteChildren: AuthenticatedUserProgramsRouteRouteChildren =
  {
    AuthenticatedUserProgramsCreateRoute: AuthenticatedUserProgramsCreateRoute,
    AuthenticatedUserProgramsIndexRoute: AuthenticatedUserProgramsIndexRoute,
    AuthenticatedUserProgramsEditIdRoute: AuthenticatedUserProgramsEditIdRoute,
  };

const AuthenticatedUserProgramsRouteRouteWithChildren =
  AuthenticatedUserProgramsRouteRoute._addFileChildren(
    AuthenticatedUserProgramsRouteRouteChildren,
  );

interface AuthenticatedUserSearchqueryperformanceRouteRouteChildren {
  AuthenticatedUserSearchqueryperformanceIdRoute: typeof AuthenticatedUserSearchqueryperformanceIdRoute;
  AuthenticatedUserSearchqueryperformanceIndexRoute: typeof AuthenticatedUserSearchqueryperformanceIndexRoute;
}

const AuthenticatedUserSearchqueryperformanceRouteRouteChildren: AuthenticatedUserSearchqueryperformanceRouteRouteChildren =
  {
    AuthenticatedUserSearchqueryperformanceIdRoute:
      AuthenticatedUserSearchqueryperformanceIdRoute,
    AuthenticatedUserSearchqueryperformanceIndexRoute:
      AuthenticatedUserSearchqueryperformanceIndexRoute,
  };

const AuthenticatedUserSearchqueryperformanceRouteRouteWithChildren =
  AuthenticatedUserSearchqueryperformanceRouteRoute._addFileChildren(
    AuthenticatedUserSearchqueryperformanceRouteRouteChildren,
  );

interface AuthenticatedUserTclipRouteRouteChildren {
  AuthenticatedUserTclipAgentsRoute: typeof AuthenticatedUserTclipAgentsRoute;
  AuthenticatedUserTclipTasksRoute: typeof AuthenticatedUserTclipTasksRoute;
  AuthenticatedUserTclipPlaygroundLazyRoute: typeof AuthenticatedUserTclipPlaygroundLazyRoute;
  AuthenticatedUserTclipTemplatesLazyRoute: typeof AuthenticatedUserTclipTemplatesLazyRoute;
  AuthenticatedUserTclipTranscriptsLazyRoute: typeof AuthenticatedUserTclipTranscriptsLazyRoute;
  AuthenticatedUserTclipAgentAgentIdLazyRoute: typeof AuthenticatedUserTclipAgentAgentIdLazyRoute;
}

const AuthenticatedUserTclipRouteRouteChildren: AuthenticatedUserTclipRouteRouteChildren =
  {
    AuthenticatedUserTclipAgentsRoute: AuthenticatedUserTclipAgentsRoute,
    AuthenticatedUserTclipTasksRoute: AuthenticatedUserTclipTasksRoute,
    AuthenticatedUserTclipPlaygroundLazyRoute:
      AuthenticatedUserTclipPlaygroundLazyRoute,
    AuthenticatedUserTclipTemplatesLazyRoute:
      AuthenticatedUserTclipTemplatesLazyRoute,
    AuthenticatedUserTclipTranscriptsLazyRoute:
      AuthenticatedUserTclipTranscriptsLazyRoute,
    AuthenticatedUserTclipAgentAgentIdLazyRoute:
      AuthenticatedUserTclipAgentAgentIdLazyRoute,
  };

const AuthenticatedUserTclipRouteRouteWithChildren =
  AuthenticatedUserTclipRouteRoute._addFileChildren(
    AuthenticatedUserTclipRouteRouteChildren,
  );

interface AuthenticatedUserAdvertisingProgramsRouteRouteChildren {
  AuthenticatedUserAdvertisingProgramsCreateRoute: typeof AuthenticatedUserAdvertisingProgramsCreateRoute;
  AuthenticatedUserAdvertisingProgramsIndexRoute: typeof AuthenticatedUserAdvertisingProgramsIndexRoute;
  AuthenticatedUserAdvertisingProgramsEditIdRoute: typeof AuthenticatedUserAdvertisingProgramsEditIdRoute;
}

const AuthenticatedUserAdvertisingProgramsRouteRouteChildren: AuthenticatedUserAdvertisingProgramsRouteRouteChildren =
  {
    AuthenticatedUserAdvertisingProgramsCreateRoute:
      AuthenticatedUserAdvertisingProgramsCreateRoute,
    AuthenticatedUserAdvertisingProgramsIndexRoute:
      AuthenticatedUserAdvertisingProgramsIndexRoute,
    AuthenticatedUserAdvertisingProgramsEditIdRoute:
      AuthenticatedUserAdvertisingProgramsEditIdRoute,
  };

const AuthenticatedUserAdvertisingProgramsRouteRouteWithChildren =
  AuthenticatedUserAdvertisingProgramsRouteRoute._addFileChildren(
    AuthenticatedUserAdvertisingProgramsRouteRouteChildren,
  );

interface AuthenticatedUserStaffReportcardRouteRouteChildren {
  AuthenticatedUserStaffReportcardOrg_idRoute: typeof AuthenticatedUserStaffReportcardOrg_idRoute;
  AuthenticatedUserStaffReportcardIndexRoute: typeof AuthenticatedUserStaffReportcardIndexRoute;
}

const AuthenticatedUserStaffReportcardRouteRouteChildren: AuthenticatedUserStaffReportcardRouteRouteChildren =
  {
    AuthenticatedUserStaffReportcardOrg_idRoute:
      AuthenticatedUserStaffReportcardOrg_idRoute,
    AuthenticatedUserStaffReportcardIndexRoute:
      AuthenticatedUserStaffReportcardIndexRoute,
  };

const AuthenticatedUserStaffReportcardRouteRouteWithChildren =
  AuthenticatedUserStaffReportcardRouteRoute._addFileChildren(
    AuthenticatedUserStaffReportcardRouteRouteChildren,
  );

interface AuthenticatedUserStaffUserActivityRouteRouteChildren {
  AuthenticatedUserStaffUserActivityOrg_idRoute: typeof AuthenticatedUserStaffUserActivityOrg_idRoute;
  AuthenticatedUserStaffUserActivityIndexRoute: typeof AuthenticatedUserStaffUserActivityIndexRoute;
}

const AuthenticatedUserStaffUserActivityRouteRouteChildren: AuthenticatedUserStaffUserActivityRouteRouteChildren =
  {
    AuthenticatedUserStaffUserActivityOrg_idRoute:
      AuthenticatedUserStaffUserActivityOrg_idRoute,
    AuthenticatedUserStaffUserActivityIndexRoute:
      AuthenticatedUserStaffUserActivityIndexRoute,
  };

const AuthenticatedUserStaffUserActivityRouteRouteWithChildren =
  AuthenticatedUserStaffUserActivityRouteRoute._addFileChildren(
    AuthenticatedUserStaffUserActivityRouteRouteChildren,
  );

interface AuthenticatedUserStaffWorkflowsRouteRouteChildren {
  AuthenticatedUserStaffWorkflowsWorkflow_idRoute: typeof AuthenticatedUserStaffWorkflowsWorkflow_idRoute;
  AuthenticatedUserStaffWorkflowsIndexRoute: typeof AuthenticatedUserStaffWorkflowsIndexRoute;
}

const AuthenticatedUserStaffWorkflowsRouteRouteChildren: AuthenticatedUserStaffWorkflowsRouteRouteChildren =
  {
    AuthenticatedUserStaffWorkflowsWorkflow_idRoute:
      AuthenticatedUserStaffWorkflowsWorkflow_idRoute,
    AuthenticatedUserStaffWorkflowsIndexRoute:
      AuthenticatedUserStaffWorkflowsIndexRoute,
  };

const AuthenticatedUserStaffWorkflowsRouteRouteWithChildren =
  AuthenticatedUserStaffWorkflowsRouteRoute._addFileChildren(
    AuthenticatedUserStaffWorkflowsRouteRouteChildren,
  );

interface AuthenticatedUserRouteRouteChildren {
  AuthenticatedUserLiveRouteRoute: typeof AuthenticatedUserLiveRouteRouteWithChildren;
  AuthenticatedUserMerchandisingRouteRoute: typeof AuthenticatedUserMerchandisingRouteRouteWithChildren;
  AuthenticatedUserPlRouteRoute: typeof AuthenticatedUserPlRouteRouteWithChildren;
  AuthenticatedUserPricingRouteRoute: typeof AuthenticatedUserPricingRouteRouteWithChildren;
  AuthenticatedUserProductlaunchRouteRoute: typeof AuthenticatedUserProductlaunchRouteRouteWithChildren;
  AuthenticatedUserProgramsRouteRoute: typeof AuthenticatedUserProgramsRouteRouteWithChildren;
  AuthenticatedUserSearchqueryperformanceRouteRoute: typeof AuthenticatedUserSearchqueryperformanceRouteRouteWithChildren;
  AuthenticatedUserTclipRouteRoute: typeof AuthenticatedUserTclipRouteRouteWithChildren;
  AuthenticatedUserAmzsummaryRoute: typeof AuthenticatedUserAmzsummaryRoute;
  AuthenticatedUserApplicationsRoute: typeof AuthenticatedUserApplicationsRoute;
  AuthenticatedUserBillingRoute: typeof AuthenticatedUserBillingRoute;
  AuthenticatedUserCategorymanagementRoute: typeof AuthenticatedUserCategorymanagementRoute;
  AuthenticatedUserChromeaccessRoute: typeof AuthenticatedUserChromeaccessRoute;
  AuthenticatedUserDashboardRoute: typeof AuthenticatedUserDashboardRoute;
  AuthenticatedUserDataStatusRoute: typeof AuthenticatedUserDataStatusRoute;
  AuthenticatedUserGoalsRoute: typeof AuthenticatedUserGoalsRoute;
  AuthenticatedUserMcpRoute: typeof AuthenticatedUserMcpRoute;
  AuthenticatedUserPaymentRoute: typeof AuthenticatedUserPaymentRoute;
  AuthenticatedUserPlansRoute: typeof AuthenticatedUserPlansRoute;
  AuthenticatedUserSearchanalyticsRoute: typeof AuthenticatedUserSearchanalyticsRoute;
  AuthenticatedUserSettingsRoute: typeof AuthenticatedUserSettingsRoute;
  AuthenticatedUserShopifysummaryRoute: typeof AuthenticatedUserShopifysummaryRoute;
  AuthenticatedUserShopperinsightsV2Route: typeof AuthenticatedUserShopperinsightsV2Route;
  AuthenticatedUserTagmanagementRoute: typeof AuthenticatedUserTagmanagementRoute;
  AuthenticatedUserTicketsRoute: typeof AuthenticatedUserTicketsRoute;
  AuthenticatedUserTrmnlRoute: typeof AuthenticatedUserTrmnlRoute;
  AuthenticatedUserUploadsRoute: typeof AuthenticatedUserUploadsRoute;
  AuthenticatedUserUsermanagementRoute: typeof AuthenticatedUserUsermanagementRoute;
  AuthenticatedUserVerifyRoute: typeof AuthenticatedUserVerifyRoute;
  AuthenticatedUserVideogenRoute: typeof AuthenticatedUserVideogenRoute;
  AuthenticatedUserWalmartsummaryRoute: typeof AuthenticatedUserWalmartsummaryRoute;
  AuthenticatedUserIndexRoute: typeof AuthenticatedUserIndexRoute;
  AuthenticatedUserAdvertisingProgramsRouteRoute: typeof AuthenticatedUserAdvertisingProgramsRouteRouteWithChildren;
  AuthenticatedUserStaffReportcardRouteRoute: typeof AuthenticatedUserStaffReportcardRouteRouteWithChildren;
  AuthenticatedUserStaffUserActivityRouteRoute: typeof AuthenticatedUserStaffUserActivityRouteRouteWithChildren;
  AuthenticatedUserStaffWorkflowsRouteRoute: typeof AuthenticatedUserStaffWorkflowsRouteRouteWithChildren;
  AuthenticatedUserAdvertisingSettingsRoute: typeof AuthenticatedUserAdvertisingSettingsRoute;
  AuthenticatedUserAgencyDashboardRoute: typeof AuthenticatedUserAgencyDashboardRoute;
  AuthenticatedUserAmcConfigurationRoute: typeof AuthenticatedUserAmcConfigurationRoute;
  AuthenticatedUserAmcShopperinsightsV2Route: typeof AuthenticatedUserAmcShopperinsightsV2Route;
  AuthenticatedUserAppsShopifyRoute: typeof AuthenticatedUserAppsShopifyRoute;
  AuthenticatedUserAudienceDashboardRoute: typeof AuthenticatedUserAudienceDashboardRoute;
  AuthenticatedUserContentSeoRoute: typeof AuthenticatedUserContentSeoRoute;
  AuthenticatedUserReportAdvertisementRoute: typeof AuthenticatedUserReportAdvertisementRoute;
  AuthenticatedUserReportAudienceRoute: typeof AuthenticatedUserReportAudienceRoute;
  AuthenticatedUserReportExportRoute: typeof AuthenticatedUserReportExportRoute;
  AuthenticatedUserReportPricing_planRoute: typeof AuthenticatedUserReportPricing_planRoute;
  AuthenticatedUserReportProductRoute: typeof AuthenticatedUserReportProductRoute;
  AuthenticatedUserReportProduct_adRoute: typeof AuthenticatedUserReportProduct_adRoute;
  AuthenticatedUserReportSqpr_reportRoute: typeof AuthenticatedUserReportSqpr_reportRoute;
  AuthenticatedUserReportStr_reportRoute: typeof AuthenticatedUserReportStr_reportRoute;
  AuthenticatedUserReportTargetRoute: typeof AuthenticatedUserReportTargetRoute;
  AuthenticatedUserStaffDashboardRoute: typeof AuthenticatedUserStaffDashboardRoute;
  AuthenticatedUserUserdetailsIdRoute: typeof AuthenticatedUserUserdetailsIdRoute;
  AuthenticatedUserAppsIndexRoute: typeof AuthenticatedUserAppsIndexRoute;
  AuthenticatedUserDspIndexRoute: typeof AuthenticatedUserDspIndexRoute;
  AuthenticatedUserAmcConversionchartReportsRoute: typeof AuthenticatedUserAmcConversionchartReportsRoute;
  AuthenticatedUserContentQualityOrgRoute: typeof AuthenticatedUserContentQualityOrgRoute;
  AuthenticatedUserContentTemplatesTemplateIdRoute: typeof AuthenticatedUserContentTemplatesTemplateIdRoute;
  AuthenticatedUserDspDspAdvertiserDashboardRoute: typeof AuthenticatedUserDspDspAdvertiserDashboardRoute;
  AuthenticatedUserReportOrganizationSummaryRoute: typeof AuthenticatedUserReportOrganizationSummaryRoute;
  AuthenticatedUserStaffWalmartProfilesRoute: typeof AuthenticatedUserStaffWalmartProfilesRoute;
  AuthenticatedUserAdvertisingDashboardIndexRoute: typeof AuthenticatedUserAdvertisingDashboardIndexRoute;
  AuthenticatedUserAmcDashboardIndexRoute: typeof AuthenticatedUserAmcDashboardIndexRoute;
  AuthenticatedUserAdvertisingDashboardAdsIdRoute: typeof AuthenticatedUserAdvertisingDashboardAdsIdRoute;
  AuthenticatedUserAdvertisingDashboardCategoryIdRoute: typeof AuthenticatedUserAdvertisingDashboardCategoryIdRoute;
  AuthenticatedUserAmcDashboardReportsIdRoute: typeof AuthenticatedUserAmcDashboardReportsIdRoute;
  AuthenticatedUserContentQualityCategoryCategoryRoute: typeof AuthenticatedUserContentQualityCategoryCategoryRoute;
  AuthenticatedUserDspDspAdvertiserLineitemsIdRoute: typeof AuthenticatedUserDspDspAdvertiserLineitemsIdRoute;
  AuthenticatedUserDspDspAdvertiserOrdersIdRoute: typeof AuthenticatedUserDspDspAdvertiserOrdersIdRoute;
  AuthenticatedUserAmcDashboardReportsDetailsIdRoute: typeof AuthenticatedUserAmcDashboardReportsDetailsIdRoute;
}

const AuthenticatedUserRouteRouteChildren: AuthenticatedUserRouteRouteChildren =
  {
    AuthenticatedUserLiveRouteRoute:
      AuthenticatedUserLiveRouteRouteWithChildren,
    AuthenticatedUserMerchandisingRouteRoute:
      AuthenticatedUserMerchandisingRouteRouteWithChildren,
    AuthenticatedUserPlRouteRoute: AuthenticatedUserPlRouteRouteWithChildren,
    AuthenticatedUserPricingRouteRoute:
      AuthenticatedUserPricingRouteRouteWithChildren,
    AuthenticatedUserProductlaunchRouteRoute:
      AuthenticatedUserProductlaunchRouteRouteWithChildren,
    AuthenticatedUserProgramsRouteRoute:
      AuthenticatedUserProgramsRouteRouteWithChildren,
    AuthenticatedUserSearchqueryperformanceRouteRoute:
      AuthenticatedUserSearchqueryperformanceRouteRouteWithChildren,
    AuthenticatedUserTclipRouteRoute:
      AuthenticatedUserTclipRouteRouteWithChildren,
    AuthenticatedUserAmzsummaryRoute: AuthenticatedUserAmzsummaryRoute,
    AuthenticatedUserApplicationsRoute: AuthenticatedUserApplicationsRoute,
    AuthenticatedUserBillingRoute: AuthenticatedUserBillingRoute,
    AuthenticatedUserCategorymanagementRoute:
      AuthenticatedUserCategorymanagementRoute,
    AuthenticatedUserChromeaccessRoute: AuthenticatedUserChromeaccessRoute,
    AuthenticatedUserDashboardRoute: AuthenticatedUserDashboardRoute,
    AuthenticatedUserDataStatusRoute: AuthenticatedUserDataStatusRoute,
    AuthenticatedUserGoalsRoute: AuthenticatedUserGoalsRoute,
    AuthenticatedUserMcpRoute: AuthenticatedUserMcpRoute,
    AuthenticatedUserPaymentRoute: AuthenticatedUserPaymentRoute,
    AuthenticatedUserPlansRoute: AuthenticatedUserPlansRoute,
    AuthenticatedUserSearchanalyticsRoute:
      AuthenticatedUserSearchanalyticsRoute,
    AuthenticatedUserSettingsRoute: AuthenticatedUserSettingsRoute,
    AuthenticatedUserShopifysummaryRoute: AuthenticatedUserShopifysummaryRoute,
    AuthenticatedUserShopperinsightsV2Route:
      AuthenticatedUserShopperinsightsV2Route,
    AuthenticatedUserTagmanagementRoute: AuthenticatedUserTagmanagementRoute,
    AuthenticatedUserTicketsRoute: AuthenticatedUserTicketsRoute,
    AuthenticatedUserTrmnlRoute: AuthenticatedUserTrmnlRoute,
    AuthenticatedUserUploadsRoute: AuthenticatedUserUploadsRoute,
    AuthenticatedUserUsermanagementRoute: AuthenticatedUserUsermanagementRoute,
    AuthenticatedUserVerifyRoute: AuthenticatedUserVerifyRoute,
    AuthenticatedUserVideogenRoute: AuthenticatedUserVideogenRoute,
    AuthenticatedUserWalmartsummaryRoute: AuthenticatedUserWalmartsummaryRoute,
    AuthenticatedUserIndexRoute: AuthenticatedUserIndexRoute,
    AuthenticatedUserAdvertisingProgramsRouteRoute:
      AuthenticatedUserAdvertisingProgramsRouteRouteWithChildren,
    AuthenticatedUserStaffReportcardRouteRoute:
      AuthenticatedUserStaffReportcardRouteRouteWithChildren,
    AuthenticatedUserStaffUserActivityRouteRoute:
      AuthenticatedUserStaffUserActivityRouteRouteWithChildren,
    AuthenticatedUserStaffWorkflowsRouteRoute:
      AuthenticatedUserStaffWorkflowsRouteRouteWithChildren,
    AuthenticatedUserAdvertisingSettingsRoute:
      AuthenticatedUserAdvertisingSettingsRoute,
    AuthenticatedUserAgencyDashboardRoute:
      AuthenticatedUserAgencyDashboardRoute,
    AuthenticatedUserAmcConfigurationRoute:
      AuthenticatedUserAmcConfigurationRoute,
    AuthenticatedUserAmcShopperinsightsV2Route:
      AuthenticatedUserAmcShopperinsightsV2Route,
    AuthenticatedUserAppsShopifyRoute: AuthenticatedUserAppsShopifyRoute,
    AuthenticatedUserAudienceDashboardRoute:
      AuthenticatedUserAudienceDashboardRoute,
    AuthenticatedUserContentSeoRoute: AuthenticatedUserContentSeoRoute,
    AuthenticatedUserReportAdvertisementRoute:
      AuthenticatedUserReportAdvertisementRoute,
    AuthenticatedUserReportAudienceRoute: AuthenticatedUserReportAudienceRoute,
    AuthenticatedUserReportExportRoute: AuthenticatedUserReportExportRoute,
    AuthenticatedUserReportPricing_planRoute:
      AuthenticatedUserReportPricing_planRoute,
    AuthenticatedUserReportProductRoute: AuthenticatedUserReportProductRoute,
    AuthenticatedUserReportProduct_adRoute:
      AuthenticatedUserReportProduct_adRoute,
    AuthenticatedUserReportSqpr_reportRoute:
      AuthenticatedUserReportSqpr_reportRoute,
    AuthenticatedUserReportStr_reportRoute:
      AuthenticatedUserReportStr_reportRoute,
    AuthenticatedUserReportTargetRoute: AuthenticatedUserReportTargetRoute,
    AuthenticatedUserStaffDashboardRoute: AuthenticatedUserStaffDashboardRoute,
    AuthenticatedUserUserdetailsIdRoute: AuthenticatedUserUserdetailsIdRoute,
    AuthenticatedUserAppsIndexRoute: AuthenticatedUserAppsIndexRoute,
    AuthenticatedUserDspIndexRoute: AuthenticatedUserDspIndexRoute,
    AuthenticatedUserAmcConversionchartReportsRoute:
      AuthenticatedUserAmcConversionchartReportsRoute,
    AuthenticatedUserContentQualityOrgRoute:
      AuthenticatedUserContentQualityOrgRoute,
    AuthenticatedUserContentTemplatesTemplateIdRoute:
      AuthenticatedUserContentTemplatesTemplateIdRoute,
    AuthenticatedUserDspDspAdvertiserDashboardRoute:
      AuthenticatedUserDspDspAdvertiserDashboardRoute,
    AuthenticatedUserReportOrganizationSummaryRoute:
      AuthenticatedUserReportOrganizationSummaryRoute,
    AuthenticatedUserStaffWalmartProfilesRoute:
      AuthenticatedUserStaffWalmartProfilesRoute,
    AuthenticatedUserAdvertisingDashboardIndexRoute:
      AuthenticatedUserAdvertisingDashboardIndexRoute,
    AuthenticatedUserAmcDashboardIndexRoute:
      AuthenticatedUserAmcDashboardIndexRoute,
    AuthenticatedUserAdvertisingDashboardAdsIdRoute:
      AuthenticatedUserAdvertisingDashboardAdsIdRoute,
    AuthenticatedUserAdvertisingDashboardCategoryIdRoute:
      AuthenticatedUserAdvertisingDashboardCategoryIdRoute,
    AuthenticatedUserAmcDashboardReportsIdRoute:
      AuthenticatedUserAmcDashboardReportsIdRoute,
    AuthenticatedUserContentQualityCategoryCategoryRoute:
      AuthenticatedUserContentQualityCategoryCategoryRoute,
    AuthenticatedUserDspDspAdvertiserLineitemsIdRoute:
      AuthenticatedUserDspDspAdvertiserLineitemsIdRoute,
    AuthenticatedUserDspDspAdvertiserOrdersIdRoute:
      AuthenticatedUserDspDspAdvertiserOrdersIdRoute,
    AuthenticatedUserAmcDashboardReportsDetailsIdRoute:
      AuthenticatedUserAmcDashboardReportsDetailsIdRoute,
  };

const AuthenticatedUserRouteRouteWithChildren =
  AuthenticatedUserRouteRoute._addFileChildren(
    AuthenticatedUserRouteRouteChildren,
  );

interface AuthenticatedOnboardingV2RouteRouteChildren {
  AuthenticatedOnboardingV2ChannelRoute: typeof AuthenticatedOnboardingV2ChannelRoute;
  AuthenticatedOnboardingV2ConnectRoute: typeof AuthenticatedOnboardingV2ConnectRoute;
  AuthenticatedOnboardingV2ProfilesRoute: typeof AuthenticatedOnboardingV2ProfilesRoute;
  AuthenticatedOnboardingV2SellertypeRoute: typeof AuthenticatedOnboardingV2SellertypeRoute;
  AuthenticatedOnboardingV2SummaryRoute: typeof AuthenticatedOnboardingV2SummaryRoute;
  AuthenticatedOnboardingV2IndexRoute: typeof AuthenticatedOnboardingV2IndexRoute;
  AuthenticatedOnboardingV2AboutSalesRoute: typeof AuthenticatedOnboardingV2AboutSalesRoute;
  AuthenticatedOnboardingV2AboutTypeRoute: typeof AuthenticatedOnboardingV2AboutTypeRoute;
}

const AuthenticatedOnboardingV2RouteRouteChildren: AuthenticatedOnboardingV2RouteRouteChildren =
  {
    AuthenticatedOnboardingV2ChannelRoute:
      AuthenticatedOnboardingV2ChannelRoute,
    AuthenticatedOnboardingV2ConnectRoute:
      AuthenticatedOnboardingV2ConnectRoute,
    AuthenticatedOnboardingV2ProfilesRoute:
      AuthenticatedOnboardingV2ProfilesRoute,
    AuthenticatedOnboardingV2SellertypeRoute:
      AuthenticatedOnboardingV2SellertypeRoute,
    AuthenticatedOnboardingV2SummaryRoute:
      AuthenticatedOnboardingV2SummaryRoute,
    AuthenticatedOnboardingV2IndexRoute: AuthenticatedOnboardingV2IndexRoute,
    AuthenticatedOnboardingV2AboutSalesRoute:
      AuthenticatedOnboardingV2AboutSalesRoute,
    AuthenticatedOnboardingV2AboutTypeRoute:
      AuthenticatedOnboardingV2AboutTypeRoute,
  };

const AuthenticatedOnboardingV2RouteRouteWithChildren =
  AuthenticatedOnboardingV2RouteRoute._addFileChildren(
    AuthenticatedOnboardingV2RouteRouteChildren,
  );

interface AuthenticatedRouteRouteChildren {
  AuthenticatedUserRouteRoute: typeof AuthenticatedUserRouteRouteWithChildren;
  AuthenticatedOnboardingV2RouteRoute: typeof AuthenticatedOnboardingV2RouteRouteWithChildren;
  AuthenticatedMcpAuthorizeRoute: typeof AuthenticatedMcpAuthorizeRoute;
  AuthenticatedWalmartInstallRoute: typeof AuthenticatedWalmartInstallRoute;
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedUserRouteRoute: AuthenticatedUserRouteRouteWithChildren,
  AuthenticatedOnboardingV2RouteRoute:
    AuthenticatedOnboardingV2RouteRouteWithChildren,
  AuthenticatedMcpAuthorizeRoute: AuthenticatedMcpAuthorizeRoute,
  AuthenticatedWalmartInstallRoute: AuthenticatedWalmartInstallRoute,
};

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren);

interface PdfRouteRouteChildren {
  PdfReportOrganizationSummaryRoute: typeof PdfReportOrganizationSummaryRoute;
}

const PdfRouteRouteChildren: PdfRouteRouteChildren = {
  PdfReportOrganizationSummaryRoute: PdfReportOrganizationSummaryRoute,
};

const PdfRouteRouteWithChildren = PdfRouteRoute._addFileChildren(
  PdfRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PdfRouteRoute: PdfRouteRouteWithChildren,
  SignupRoute: SignupRoute,
  ConnectTiktokRoute: ConnectTiktokRoute,
  ShopifyInstallRoute: ShopifyInstallRoute,
  SigninResetpasswordRoute: SigninResetpasswordRoute,
  SigninIndexRoute: SigninIndexRoute,
  OauthAmazonAdvertisingRoute: OauthAmazonAdvertisingRoute,
  OauthAmazonSpapiRoute: OauthAmazonSpapiRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
